const el = {
  common: {
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    confirm: 'Επιβεβαίωση',
    delete: 'Διαγραφή',
    cancelDelete: 'Ακύρωση διαγραφής',
    edit: 'Επεξεργασία',
    add: 'Προσθήκη',
    create: 'Δημιουργία',
    back: 'Πίσω',
    search: 'Αναζήτηση',
    remove: 'Αφαίρεση',
    close: 'Κλείσιμο',
    closeMenu: 'Κλείσιμο μενού',
    loading: 'Φόρτωση...',
    somethingWentWrong: 'Κάτι πήγε στραβά',
    yes: 'Ναι',
    no: 'Όχι',
    required: 'Υποχρεωτικό',
    noResults: 'Δεν υπάρχουν αποτελέσματα',
    home: 'Αρχική',
    link: 'Σύνδεση',
    showPassword: 'Εμφάνιση κωδικού',
    hidePassword: 'Απόκρυψη κωδικού',
  },
  serviceUnavailable: {
    title: 'Η υπηρεσία δεν είναι διαθέσιμη',
    message: 'Αυτή τη στιγμή δεν είναι δυνατή η σύνδεση με την υπηρεσία.<br/>Παρακαλούμε δοκιμάστε ξανά σε λίγο.',
    retry: 'Δοκιμάστε ξανά',
    retryCooldown: 'Δοκιμάστε ξανά ({{seconds}})',
  },
  header: {
    welcome: 'Καλώς ήρθες,',
    logout: 'Αποσύνδεση',
    language: 'Γλώσσα',
    languageGreek: 'Ελληνικά',
    languageEnglish: 'English',
  },
  branchSelector: {
    selectBranchTitle: 'Επιλογή υποκαταστήματος',
    selectBranchLabel: 'Επιλογή υποκαταστήματος:',
    save: 'Αποθήκευση',
  },
  menu: {
    overview: 'Επισκόπηση',
    contacts: 'Επαφές',
    leads: 'Leads',
    companies: 'Εταιρείες',
    orders: 'Παραγγελίες',
    employees: 'Υπάλληλοι',
    bookings: 'Ημερολόγιο',
    services: 'Υπηρεσίες',
    settings: 'Ρυθμίσεις',
    statistics: 'Στατιστικά',
    ergani: 'ΕΡΓΑΝΗ',
    workCard: 'Κάρτα Εργασίας',
  },
  admin: {
    title: 'Διαχείριση',
    tenants: {
      title: 'Tenants',
      addButton: 'Προσθήκη tenant',
      list: {
        subtitle: 'Διαχείριση οργανισμών, πλάνων και πρόσβασης tenant.',
        searchPlaceholder: 'Αναζήτηση με όνομα ή ID οργανισμού',
        remindersChip: 'Υπενθυμίσεις',
        totalTenants: 'Σύνολο tenants',
        featuresCount_one: '{{count}} feature',
        featuresCount_other: '{{count}} features',
      },
      empty: 'Δεν βρέθηκαν tenants',
      featurePlaceholder: 'Επιλογή features',
      smsDisabled: 'SMS απενεργοποιημένα',
      senderWarning:
        'Αντιγράψτε το ακριβές sender ID από την κονσόλα του παρόχου. <b>Αυτή η τιμή δεν μπορεί να αλλάξει στη συνέχεια.</b> Το Bookingplus δεν μπορεί να την επικυρώσει: μια μη καταχωρημένη τιμή δεν απορρίπτεται — ο πάροχος αντικαθιστά τον αποστολέα ή απορρίπτει το μήνυμα.',
      quotaUsage: '{{used}} / {{limit}} χρησιμοποιήθηκαν από {{date}}',
      sections: { identity: 'Ταυτότητα', plan: 'Πλάνο', limits: 'Όρια', smsQuota: 'Όριο SMS' },
      fields: {
        name: 'Όνομα',
        alias: 'Alias',
        organizationId: 'ID οργανισμού',
        tier: 'Tier',
        features: 'Features',
        branchLimit: 'Όριο καταστημάτων',
        smsLimit: 'Όριο SMS',
        senderName: 'Όνομα αποστολέα',
      },
      buttons: { save: 'Αποθήκευση', renewQuota: 'Ανανέωση ορίου', changeSender: 'Αλλαγή αποστολέα' },
      dialogs: { renewTitle: 'Ανανέωση ορίου SMS', changeSenderTitle: 'Αλλαγή ονόματος αποστολέα' },
      validation: { mobileInvalid: 'Το κινητό δεν είναι έγκυρο' },
      snackbars: {
        created: 'Ο tenant δημιουργήθηκε επιτυχώς!',
        createFailed: 'Η δημιουργία του tenant απέτυχε',
        updated: 'Ο tenant ενημερώθηκε επιτυχώς!',
        updateFailed: 'Η ενημέρωση του tenant απέτυχε',
        loadFailed: 'Η φόρτωση του tenant απέτυχε',
        quotaRenewed: 'Το όριο SMS ανανεώθηκε επιτυχώς',
      },
      detail: {
        planLimitsTitle: 'Πλάνο & όρια',
        tierLabel: 'Tier *',
        featuresLabel: 'Features',
        aliasLabel: 'Alias',
        organizationIdLabel: 'ID οργανισμού',
        reminders: {
          title: 'Υπενθυμίσεις κρατήσεων',
          on: 'Ενεργό',
          off: 'Ανενεργό',
          subtitleConfigured: 'Στέλνονται SMS υπενθυμίσεις στους πελάτες πριν το ραντεβού τους.',
          setupInProgress: 'Σε διαμόρφωση',
          setupButton: 'Ρύθμιση',
          cancelSetup: 'Ακύρωση ρύθμισης',
          subtitleSetup: 'Απομένουν τρία βήματα πριν μπορεί να αποθηκευτεί',
          subtitleOffNotConfigured: 'Ανενεργό · Δεν έχει διαμορφωθεί SMS για αυτόν τον tenant',
          subtitleOffDisabled: 'Ανενεργό · Οι υπενθυμίσεις SMS είναι απενεργοποιημένες',
          infoBanner:
            'Οι υπενθυμίσεις παραμένουν ανενεργές μέχρι να ολοκληρώσετε τη διαμόρφωση και να πατήσετε Αποθήκευση. Το feature δεν μπορεί να ενεργοποιηθεί χωρίς την υποβολή της παρακάτω διαμόρφωσης SMS.',
        },
        steps: {
          mobileNumberLabel: 'Αριθμός κινητού *',
          step1: {
            title: 'Καταχωρήστε το όνομα αποστολέα στον πάροχο SMS',
            description:
              'Γίνεται εκτός Bookingplus και δεν μπορεί να αυτοματοποιηθεί ή να ελεγχθεί από εδώ. Καταχωρήστε πρώτα το sender ID για αυτόν τον tenant και μετά καταγράψτε το παρακάτω.',
            link: 'Άνοιγμα κονσόλας παρόχου',
            done: 'Καταχωρήθηκε στον πάροχο',
          },
          step2: {
            title: 'Καταγραφή ονόματος αποστολέα',
            placeholder: 'π.χ. BKPLUS',
            helper: 'Έως 11 αλφαριθμητικοί χαρακτήρες, όπως έχει καταχωρηθεί στον πάροχο',
            setButton: 'Καταχώρηση',
            doneRecorded: 'Το όνομα αποστολέα <code>{{name}}</code> καταγράφηκε',
            doneCaption: 'Δεν γράφεται στον tenant μέχρι την Αποθήκευση — το Άκυρο το απορρίπτει ακόμα',
          },
          step3: {
            title: 'Επιβεβαίωση με δοκιμαστικό SMS',
            descriptionReady:
              'Στέλνει ένα πραγματικό μήνυμα ως <code>{{sender}}</code> σε έναν αριθμό που μπορείτε να διαβάσετε. Δεν προσμετράται στο όριο, αλλά χρεώνεται από τον πάροχο.',
            descriptionMuted: 'Διαθέσιμο αφού καταγραφεί το όνομα αποστολέα.',
            mobileHelper: 'Χρησιμοποιήστε ένα τηλέφωνο που μπορείτε να ελέγξετε τώρα',
            sendButton: 'Δοκιμαστικό SMS',
            verified: '✓ Το SMS παραλήφθηκε και ο αποστολέας επιβεβαιώθηκε',
          },
          step4: {
            title: 'Ορισμός ορίου SMS',
            descriptionReady: 'Ανοίγει νέο παράθυρο χρήσης από τώρα.',
            descriptionMuted: 'Διαθέσιμο μόλις επιβεβαιώσετε ότι παραλάβατε το δοκιμαστικό SMS.',
            limitLabel: 'Όριο SMS ανά παράθυρο *',
            limitError: 'Πρέπει να είναι μεγαλύτερο από 0 — όριο 0 αφήνει τον tenant χωρίς δυνατότητα αποστολής',
            setButton: 'Ορισμός ορίου',
            done: 'Το όριο SMS ορίστηκε σε <code>{{limit}}</code> ανά παράθυρο',
          },
        },
        renewDialog: { limitLabel: 'Όριο SMS ανά παράθυρο', confirm: 'Επιβεβαίωση' },
        testDialog: {
          titleBefore: 'Αποστολή δοκιμαστικού SMS',
          titleAfter: 'Το δοκιμαστικό SMS παραδόθηκε στον πάροχο',
          intro: 'Ένα πραγματικό μήνυμα, σταλμένο ως <code>{{sender}}</code> σε έναν αριθμό που μπορείτε να ελέγξετε.',
          mobileHelper:
            'Χρησιμοποιήστε ένα τηλέφωνο που μπορείτε να διαβάσετε τώρα — θα χρειαστεί να συγκρίνετε τον αποστολέα που θα εμφανιστεί.',
          infoNote:
            'Το μήνυμα αναφέρει τον διαμορφωμένο αποστολέα στο περιεχόμενό του. Αν ο αποστολέας που εμφανίζεται στο τηλέφωνό σας διαφέρει, το sender ID δεν είναι καταχωρημένο στον πάροχο.',
          senderUsed: 'Αποστολέας που χρησιμοποιήθηκε',
          smsId: 'ID SMS',
          recipient: 'Παραλήπτης',
          deliveryState: 'Κατάσταση παράδοσης',
          stateDelivered: 'παραδόθηκε',
          stateFailed: 'απέτυχε η παράδοση',
          statePending: 'δεν έχει έρθει ακόμα callback από τον πάροχο',
          pendingExplainer:
            'Το PENDING σημαίνει ότι δεν έχει φτάσει callback παράδοσης — δεν σημαίνει ότι το μήνυμα απέτυχε. Το τηλέφωνό σας είναι η πηγή αλήθειας.',
          confirmReceived: 'Παρέλαβα το SMS και ήρθε από <code>{{sender}}</code>',
          confirmCaption: 'Ξεκλειδώνει το βήμα ορίου. Θυμάται μόνο για αυτή την επίσκεψη — η ανανέωση της σελίδας ρωτάει ξανά.',
          sendAnother: 'Αποστολή άλλου',
          continueToQuota: 'Συνέχεια στο όριο',
          sendReal: 'Αποστολή πραγματικού SMS',
          sending: 'Αποστολή…',
        },
        saveBlockedHint: 'Ολοκληρώστε τη διαμόρφωση SMS για να αποθηκεύσετε',
        leaveDialog: {
          title: 'Απόρριψη μη αποθηκευμένων αλλαγών;',
          body: 'Οι αλλαγές σε αυτή τη σελίδα, μαζί με την πρόοδο ρύθμισης υπενθυμίσεων, θα χαθούν.',
          stay: 'Παραμονή',
          discard: 'Απόρριψη',
        },
        offDialog: {
          title: 'Διακοπή αποστολής υπενθυμίσεων κρατήσεων;',
          body: 'Οι πελάτες του <b>{{name}}</b> σταματούν να λαμβάνουν SMS υπενθυμίσεις μόλις αποθηκευτεί αυτό.',
          caption: 'Το όνομα αποστολέα, το όριο και η χρήση διατηρούνται — η επανενεργοποίηση αργότερα δεν χρειάζεται νέα διαμόρφωση.',
          keepSending: 'Συνέχιση',
          turnOff: 'Απενεργοποίηση',
        },
        configured: {
          title: 'Διαμόρφωση SMS',
          senderHelper:
            'Έως 11 αλφαριθμητικοί χαρακτήρες. Μόνιμο μόλις αποθηκευτεί — πρέπει να ταιριάζει με το sender ID που έχει καταχωρηθεί στον πάροχο. Στείλτε δοκιμαστικό SMS όποτε θέλετε για επανέλεγχο παράδοσης.',
          smsLimitLabel: 'Όριο SMS ανά παράθυρο *',
          limitHelper: 'Αλλάζει μόνο μέσω της Ανανέωσης ορίου παρακάτω, που ανοίγει επίσης νέο παράθυρο χρήσης από τώρα.',
          usageTitle: 'Χρήση SMS σε αυτό το παράθυρο',
          since: 'Από {{date}} · προηγούμενα παράθυρα δεν προσμετρώνται',
          ofUsed: 'από {{limit}} χρησιμοποιήθηκαν',
          remaining: '{{count}} απομένουν',
          threshold: 'όριο προειδοποίησης 80%',
          warning: 'Ξεπεράστηκε το όριο του 80%. Ανανεώστε το πριν εξαντληθεί το όριο ή σταματήσουν οι υπενθυμίσεις.',
          delivered: 'Παραδόθηκαν',
          pending: 'Σε εκκρεμότητα',
          failed: 'Απέτυχαν',
          windowOpened: 'Άνοιγμα παραθύρου',
          footnote:
            'Παραδόθηκαν + σε εκκρεμότητα + απέτυχαν = {{usage}}, ο αριθμός που προσμετράται στο όριο. Οι αποτυχημένες και εκκρεμείς αποστολές προσμετρήθηκαν επίσης — ο πάροχος κλήθηκε ούτως ή άλλως.',
        },
        snackbars: { testSmsSent: 'Το δοκιμαστικό SMS παραδόθηκε στον πάροχο', testSmsFailed: 'Η αποστολή του δοκιμαστικού SMS απέτυχε' },
      },
    },
  },
  breadcrumbs: {
    contacts: 'Επαφές',
    services: 'Υπηρεσίες',
    employees: 'Υπάλληλοι',
    orders: 'Παραγγελίες',
    settings: 'Ρυθμίσεις',
    employeePlan: 'Ημερολόγιο',
    workCard: 'Κάρτα Εργασίας',
    ergani: 'Υπάλληλοι Εργάνης',
    attendance: 'Στοιχεία προσέλευσης/αποχώρησης',
  },
  enums: {
    companyType: {
      IKE: 'Ιδιωτική κεφαλαιουχική εταιρεία',
      EPE: 'Εταιρεία περιορισμένης ευθύνης',
      AE: 'Ανώνυμη εταιρεία',
      OE: 'Ομόρρυθμη εταιρεία',
      EE: 'Ετερόρρυθμη εταιρεία',
      SOLE_PROPRIETORSHIP: 'Ατομική επιχείρηση',
    },
    companyRole: {
      OWNER: 'Ιδιοκτήτης',
    },
    bookingStatus: {
      ACTIVE: 'Σε Ισχύ',
      COMPLETED: 'Ολοκληρωμένο',
      CANCELLED: 'Ακυρωμένο',
      NO_SHOW: 'Χωρίς προσέλευση',
      PENDING: 'Μη επιβεβαιωμένο',
    },
    communicationStatus: {
      DRAFT: 'Πρόχειρη',
      IN_PROGRESS: 'Σε Εξέλιξη',
      RECALL: 'Recall',
      REJECTED: 'Απορριφθείσα',
      COMPLETED: 'Ολοκληρωμένη',
    },
    orderStatus: {
      DRAFT: 'Πρόχειρη',
      SUBMITTED: 'Υποβληθείσα',
      UNDER_NEGOTIATION: 'Υπό Διαπραγμάτευση',
      ACCEPTED: 'Αποδεκτή',
      REJECTED: 'Απορριφθείσα',
      CANCELLED: 'Ακυρωμένη',
      EXPIRED: 'Ληγμένη',
      PENDING: 'Σε Εκκρεμότητα',
      PROCESSING: 'Σε Επεξεργασία',
      COMPLETED: 'Ολοκληρωμένη',
      ON_HOLD: 'Σε Αναμονή',
      FAILED: 'Απέτυχε',
      SHIPPED: 'Απεσταλμένη',
    },
    gender: {
      FEMALE: 'Γυναίκα',
      MALE: 'Άνδρας',
      OTHER: 'Άλλο',
      UNKNOWN: 'Άγνωστο',
    },
    dayOfWeek: {
      MONDAY: 'Δευτέρα',
      TUESDAY: 'Τρίτη',
      WEDNESDAY: 'Τετάρτη',
      THURSDAY: 'Πέμπτη',
      FRIDAY: 'Παρασκευή',
      SATURDAY: 'Σάββατο',
      SUNDAY: 'Κυριακή',
    },
    paymentMethod: {
      BANK_TRANSFER: 'Τραπεζικό Έμβασμα',
      CASH: 'Μετρητά',
      CARD: 'Κάρτα',
      ON_CREDIT: 'Επί Πιστώσει',
    },
    invoicePaymentMethod: {
      DEBIT_CARD: 'Χρεωστική κάρτα',
      CREDIT_CARD: 'Πιστωτική κάρτα',
      CASH: 'Μετρητά',
    },
    invoiceStatus: {
      DRAFT: 'Προσχέδιο',
      PENDING: 'Εκκρεμεί επιβεβαίωση',
      ISSUED: 'Εκδόθηκε',
      FAILED: 'Απορρίφθηκε από την ΑΑΔΕ',
      CANCELLED: 'Ακυρώθηκε',
      REVERSED: 'Πιστώθηκε',
      DISCARDED: 'Καταργήθηκε',
    },
    invoiceDocumentType: {
      SERVICE_RECEIPT: 'Απόδειξη Παροχής Υπηρεσιών',
      RETAIL_CREDIT_NOTE: 'Πιστωτικό Στοιχείο Λιανικής',
      SERVICE_INVOICE: 'Τιμολόγιο Παροχής Υπηρεσιών',
      SERVICE_CREDIT_INVOICE: 'Πιστωτικό Τιμολόγιο',
    },
    country: {
      AT: 'Αυστρία',
      BE: 'Βέλγιο',
      BG: 'Βουλγαρία',
      HR: 'Κροατία',
      CY: 'Κύπρος',
      CZ: 'Τσεχία',
      DK: 'Δανία',
      EE: 'Εσθονία',
      FI: 'Φινλανδία',
      FR: 'Γαλλία',
      DE: 'Γερμανία',
      GR: 'Ελλάδα',
      HU: 'Ουγγαρία',
      IE: 'Ιρλανδία',
      IT: 'Ιταλία',
      LV: 'Λετονία',
      LT: 'Λιθουανία',
      LU: 'Λουξεμβούργο',
      MT: 'Μάλτα',
      NL: 'Ολλανδία',
      PL: 'Πολωνία',
      PT: 'Πορτογαλία',
      RO: 'Ρουμανία',
      SK: 'Σλοβακία',
      SI: 'Σλοβενία',
      ES: 'Ισπανία',
      SE: 'Σουηδία',
      GB: 'Ηνωμένο Βασίλειο',
    },
    providerStatus: {
      PENDING_ACTIVATION: 'Εκκρεμεί ενεργοποίηση',
      ACTIVE: 'Ενεργό',
      PENDING_MANUAL_LINK: 'Εκκρεμεί σύνδεση από την υποστήριξη',
      FAILED: 'Απέτυχε',
    },
    providerActivationRequirement: {
      LEGAL_NAME: 'Χρειάζεται η επωνυμία της επιχείρησης.',
      REGISTERED_ADDRESS: 'Χρειάζεται η έδρα της επιχείρησης.',
      UNIQUE_CONTACT_EMAIL: 'Χρειάζεται email επικοινωνίας που δεν χρησιμοποιείται από άλλη επιχείρηση.',
      CONTACT_PHONE: 'Χρειάζεται τηλέφωνο επικοινωνίας.',
    },
  },
  searchDialogs: {
    company: {
      titleNew: 'Σύνδεση εταιρείας',
      titleEdit: 'Ενημέρωση σύνδεσης επαφής-εταιρείας',
      companyLabel: 'Εταιρεία',
      roleLabel: 'Ρόλος',
      saveButton: 'Αποθήκευση',
      linkButton: 'Σύνδεση',
    },
    contact: {
      titleNew: 'Σύνδεση επαφής',
      titleEdit: 'Ενημέρωση σύνδεσης επαφής-εταιρείας',
      contactLabel: 'Επαφή',
      roleLabel: 'Ρόλος',
      saveButton: 'Αποθήκευση',
      linkButton: 'Σύνδεση',
    },
  },
  contacts: {
    listTitle: 'Επαφές',
    addContact: 'Δημιουργία επαφής',
    backToList: 'Λίστα επαφών',
    createTitle: 'Δημιουργία επαφής',
    select: 'Επιλέξτε',
    columns: {
      lastName: 'Επώνυμο',
      firstName: 'Όνομα',
      mobilePhone: 'Κινητό τηλέφωνο',
      additionalPhone: 'Σταθερό τηλέφωνο',
      email: 'Email',
      source: 'Πηγή',
      branch: 'Κατάστημα',
    },
    tooltips: {
      lead: 'Lead (έχει προσφορά/παραγγελία)',
      customer: 'Πελάτης (έχει ολοκληρωμένη παραγγελία)',
      mobileCheck: 'Έλεγχος Χρήσης Τηλεφωνικού Αριθμού σε Υφιστάμενες Επαφές',
    },
    search: {
      mobilePlaceholder: 'Όνομα, Επίθετο, Κινητό, Email',
    },
    sections: {
      basicInfo: 'Βασικές πληροφορίες',
      contactInfo: 'Στοιχεία επικοινωνίας',
      additionalInfo: 'Συμπληρωματικές πληροφορίες',
      linkedCompanies: 'Συνδεδεμένες εταιρείες',
      bookingReminders: 'Υπενθυμίσεις επερχόμενων ραντεβού',
    },
    reminders: {
      lede: 'Τι έχει συμφωνήσει να λαμβάνει αυτός ο πελάτης πριν από τα επερχόμενα ραντεβού του. Η καταγραφή ισχύει για όλα τα ραντεβού του, όχι για κάποιο συγκεκριμένο.',
      confirmationsNotice:
        'Οι επιβεβαιώσεις και οι ακυρώσεις ραντεβού αποστέλλονται πάντα, ανεξάρτητα από αυτή την καταγραφή. Η καταγραφή αφορά μόνο τις υπενθυμίσεις πριν από ένα επερχόμενο ραντεβού — τίποτε άλλο.',
      permanence:
        'Κάθε αλλαγή σε αυτή την καταγραφή αποθηκεύεται μόνιμα, με το όνομά σας και την ώρα που την κάνατε, και δεν μπορεί να διορθωθεί ή να διαγραφεί αργότερα — μαζί με ό,τι δώσατε ως λόγο.',
      // Shown only when the record itself is ready and something the section cannot display
      // is what blocks the save. A missing reason is never this: it says so in its own box.
      blockedElsewhere:
        'Δεν μπορεί να αποθηκευτεί ακόμη: κάποιο άλλο πεδίο αυτής της καρτέλας χρειάζεται διόρθωση. Ελέγξτε τα πεδία πιο πάνω.',
      statement: {
        prefix: 'Αυτός ο πελάτης',
        on: 'λαμβάνει υπενθυμίσεις {{channel}}',
        off: 'ζήτησε να σταματήσουν οι υπενθυμίσεις {{channel}}',
      },
      // Says WHEN and nothing else: the channel is already named, in bold, on the line
      // above. Kept as two keys rather than one shared string so a channel can say
      // something different later without unpicking the callers.
      description: {
        email: 'Πριν από κάθε επερχόμενο ραντεβού του',
        sms: 'Πριν από κάθε επερχόμενο ραντεβού του',
      },
      options: {
        on: 'Τις λαμβάνει',
        off: 'Ζήτησε να σταματήσουν',
      },
      reason: {
        label: 'Γιατί ο πελάτης λαμβάνει ξανά υπενθυμίσεις {{channel}};',
        why: 'Ο πελάτης είχε ζητήσει να σταματήσουν. Η αναίρεση μιας καταγεγραμμένης επιθυμίας χρειάζεται γραπτή αιτιολόγηση.',
        scope:
          'Καταγράφεται μόνο στις υπενθυμίσεις {{channel}} — όχι στις υπόλοιπες — και δεν μπορεί να διορθωθεί ή να διαγραφεί αργότερα. Γράψτε τι ζήτησε ο πελάτης και πότε.',
        hint: 'Μην καταχωρείτε δεδομένα υγείας, διαγνώσεις ή προσωπικές συνθήκες. Περιγράψτε το αίτημα, όχι τον πελάτη. Ό,τι γράψετε εδώ μένει μόνιμα στην καταγραφή αυτού του πελάτη.',
        counter: '{{count}} / {{max}}',
        required: 'Καταγράψτε γιατί ο πελάτης λαμβάνει ξανά υπενθυμίσεις {{channel}}',
        tooLong: 'Ο λόγος δεν μπορεί να ξεπερνά τους {{max}} χαρακτήρες',
        // Names no channel on purpose: the refusal identifies it only inside an English
        // sentence, and guessing which one it meant would attribute the amendment wrongly.
        conflict:
          'Ο πελάτης είχε ζητήσει να σταματήσουν οι υπενθυμίσεις, οπότε η αναίρεση χρειάζεται γραπτή αιτιολόγηση. Ελέγξτε ότι κάθε κανάλι που ενεργοποιήσατε ξανά έχει αιτιολόγηση και αποθηκεύστε πάλι. Δεν έχει καταγραφεί καμία αλλαγή.',
      },
    },
    fields: {
      mobilePhone: 'Κινητό τηλέφωνο',
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      additionalPhone: 'Σταθερό τηλέφωνο',
      email: 'Email',
      facebook: 'Facebook',
      gender: 'Φύλο',
      occupation: 'Επάγγελμα',
      dateOfBirth: 'Γενέθλια',
      acquisitionSource: 'Πού μας βρήκατε',
      address: 'Διεύθυνση',
      branch: 'Κατάστημα Καταχώρησης',
      notes: 'Παρατηρήσεις',
    },
    snackbars: {
      saved: 'Η επαφή αποθηκεύτηκε επιτυχώς!',
      saveFailed: 'Η αποθήκευση της επαφής απέτυχε',
      notFound: 'Η επαφή δεν βρέθηκε',
      mobileCheckFailed: 'Κάτι πήγε στραβά κατά τον έλεγχο του κινητού',
      contactLinked: 'Η επαφή συνδέθηκε με την εταιρεία',
      contactUnlinked: 'Η επαφή αφαιρέθηκε από την εταιρεία',
    },
    validation: {
      mobileInUse:
        'Το κινητό τηλέφωνο χρησιμοποιείται ήδη από τις επαφές {{names}}. Μπορείτε να το χρησιμοποιήσετε ξανά με διαφορετικό όνομα, αλλά ΠΡΟΣΟΧΗ θα έχετε δύο ή περισσότερες επαφές με το ίδιο κινητό.',
      mobileRequired: 'Το κινητό είναι υποχρεωτικό',
      mobileInvalid: 'Το κινητό δεν είναι έγκυρο',
      firstNameRequired: 'Το όνομα είναι υποχρεωτικό',
      genderInvalid: 'Η τιμή που επιλέξατε δεν είναι μέσα στις επιτρεπτές τιμές.',
      additionalPhoneInvalid: 'Ο αριθμός σταθερού δεν είναι έγκυρος',
      emailInvalid: 'Η διεύθυνση email δεν είναι έγκυρη',
      facebookInvalid: 'Η διεύθυνση του προφίλ δεν είναι έγκυρη',
    },
    communication: {
      employeeRequired: 'Ο υπάλληλος είναι υποχρεωτικός',
      statusRequired: 'Η κατάσταση είναι υποχρεωτική',
      dateRequired: 'Η ημερομηνία είναι υποχρεωτική',
      reminderRequired: 'Η ημερομηνία υπενθύμισης είναι υποχρεωτική για Recall',
    },
    companiesSection: {
      linkCompany: 'Σύνδεση εταιρείας',
      columns: {
        legalName: 'Επωνυμία',
        type: 'Τύπος',
        roles: 'Ρόλοι',
      },
      unlink: {
        title: 'Αποσύνδεση από εταιρεία',
        content: 'Θέλετε να αποσυνδέσετε την επαφή από την εταιρεία {{companyName}}?',
        confirm: 'Αποσύνδεση',
      },
    },
    communications: {
      list: {
        title: 'Επικοινωνίες ({{count}})',
        newButton: 'Νέα επικοινωνία',
        columns: {
          date: 'Ημερομηνία',
          employee: 'Υπάλληλος',
          contact: 'Επαφή',
          status: 'Κατάσταση',
          notes: 'Σημειώσεις',
        },
        reminderTooltip: 'Υπενθύμιση: {{date}}',
        noRows: 'Δεν υπάρχουν επικοινωνίες',
        loadFailed: 'Σφάλμα κατά τη φόρτωση επικοινωνιών',
        deleted: 'Η επικοινωνία διαγράφηκε επιτυχώς',
        deleteFailed: 'Σφάλμα κατά τη διαγραφή της επικοινωνίας',
        deleteTitle: 'Διαγραφή επικοινωνίας',
        deleteContent: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την επικοινωνία;',
        deleteConfirm: 'Διαγραφή',
      },
      modal: {
        createTitle: 'Νέα επικοινωνία',
        editTitle: 'Επεξεργασία επικοινωνίας',
        fields: {
          employee: 'Υπάλληλος',
          date: 'Ημερομηνία',
          status: 'Κατάσταση',
          recallDateTime: 'Ημερομηνία & ώρα υπενθύμισης',
          notes: 'Σημειώσεις',
        },
        createSuccess: 'Η επικοινωνία δημιουργήθηκε επιτυχώς',
        updateSuccess: 'Η επικοινωνία ενημερώθηκε επιτυχώς',
        saveFailed: 'Σφάλμα κατά την αποθήκευση της επικοινωνίας',
        createButton: 'Δημιουργία',
        saveButton: 'Αποθήκευση',
        cancelButton: 'Ακύρωση',
      },
    },
  },
  leads: {
    listTitle: 'Leads',
    createOrder: 'Δημιουργία παραγγελίας',
    columns: {
      lastName: 'Επώνυμο',
      firstName: 'Όνομα',
      mobilePhone: 'Κινητό',
      email: 'Email',
      leadManager: 'Υπάλληλος (leader)',
      participants: 'Συμμετέχοντες',
      lastOrder: 'Τελευταία παραγγελία',
    },
    tooltips: {
      customer: 'Πελάτης (έχει ολοκληρωμένη παραγγελία)',
      viewOrder: 'Προβολή παραγγελίας',
    },
  },
  employees: {
    listTitle: 'Υπάλληλοι',
    addEmployee: 'Προσθήκη υπαλλήλου',
    erganiEmployeesButton: 'Υπάλληλοι Εργάνης',
    availableSlots: 'Διαθέσιμες θέσεις: {{count}}',
    active: 'Ενεργός',
    inactive: 'Μη ενεργός',
    backToList: 'Λίστα Υπαλλήλων',
    createTitle: 'Προσθήκη υπαλλήλου',
    columns: {
      lastName: 'Επώνυμο',
      firstName: 'Όνομα',
      mobilePhone: 'Κινητό τηλέφωνο',
      email: 'Email',
      specialties: 'Ειδικότητες',
      status: 'Κατάσταση',
      isErganiEmployee: 'Υπάλληλος Εργάνης',
    },
    tabs: {
      basicInfo: 'Βασικές Πληροφορίες',
      employmentInfo: 'Στοιχεία εργασίας',
      schedule: 'Ωράριο υπαλλήλου',
      attendance: 'Προσελεύσεις/Αποχωρήσεις',
      communications: 'Επικοινωνίες',
    },
    steps: {
      basicInfo: 'Βασικές Πληροφορίες',
      workInfo: 'Στοιχεία εργασίας',
    },
    fields: {
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      email: 'Email',
      mobilePhone: 'Κινητό τηλέφωνο',
      taxIdentificationNumber: 'ΑΦΜ',
      taxOffice: 'ΔΟΥ',
      nationalInsuranceNumber: 'ΑΜΑ',
      iban: 'IBAN',
      bank: 'Τράπεζα',
      socialSecurityNumber: 'ΑΜΚΑ',
      additionalMobilePhone: '2ο κινητό τηλέφωνο',
      additionalPhone: 'Σταθερό τηλέφωνο',
      facebook: 'Facebook',
      serviceGroup: 'Ειδικότητα',
      contractualWorkWeekHours: 'Ώρες απασχόλησης',
      grossWage: 'Μεικτός μισθός',
      netWage: 'Καθαρός Μισθός',
      contractStart: 'Ημερομηνία έναρξης σύμβασης',
      contractEnd: 'Ημερομηνία λήξης σύμβασης',
      isErganiEmployee: 'Υπάλληλος Εργάνης',
    },
    placeholders: {
      fillIban: 'Συμπληρώστε το IBAN',
    },
    tooltips: {
      mobileCheck: 'Έλεγχος Χρήσης Τηλεφωνικού Αριθμού σε Υφιστάμενους Υπαλλήλους',
      contractEndAutoDeactivate: 'Αυτόματη Απενεργοποίηση Προσωπικού μετά τη Λήξη Σύμβασης',
      contractEndDeactivates: 'Μετά το πέρας της ημερομηνίας λήξης σύμβασης ο υπάλληλος γίνεται ανενεργός',
      edit: 'Επεξεργασία',
      sendWorkCard:
        'Αποστέλλει τον QR κωδικό της κάρτας εργασίας στο email του υπαλλήλου. Αν δεν έχει πρόσβαση στον κωδικό, μπορείτε να τον ξαναστείλετε από εδώ.',
    },
    actions: {
      sendWorkCard: 'Αποστολή κάρτας εργασίας',
      previous: 'Προηγούμενο',
      next: 'Επόμενο',
      check: 'Έλεγχος',
      continue: 'Συνέχεια',
      newContact: 'Νέα επαφή',
    },
    dialogs: {
      mobileCheck: {
        title: 'Έλεγχος κινητού τηλεφώνου',
        description: 'Ελέγχεις αν το κινητό τηλέφωνο που θέλεις να εισάγεις χρησιμοποιείται ήδη σε μια ή περισσότερες επαφές',
      },
      contactExists: {
        title: 'Επιλογή επαφής',
        usedBy: 'Το κινητό τηλέφωνο <b>{{phone}}</b> χρησιμοποιείται:',
        inEmployees: 'Στους παρακάτω εργαζομένους',
        inContacts: 'Στις παρακάτω επαφές',
        help: {
          title: 'Τι να πατήσω?',
          continue: '<b>Συνέχεια</b> για να γίνει προσυμπλήρωση στοιχείων.',
          newContact:
            '<b>Νέα επαφή</b> για να δημιουργήσετε επαφή με το παρόν κινητό και διαφορετικό όνομα. Προσοχή έτσι θα έχετε δύο ή περισσότερες επαφές με το ίδιο κινητό.',
          cancel: '<b>Ακύρωση</b> ώστε να εισάγετε νέο κινητό τηλέφωνο.',
        },
      },
    },
    snackbars: {
      saved: 'Ο υπάλληλος αποθηκεύτηκε επιτυχώς!',
      saveFailed: 'Η αποθήκευση του υπαλλήλου απέτυχε',
      notFound: 'Ο υπάλληλος δεν βρέθηκε',
      ibanCheckFailed: 'Κάτι πήγε στραβά κατά τον έλεγχο του IBAN',
      mobileCheckFailed: 'Κάτι πήγε στραβά κατά τον έλεγχο του κινητού',
      workCardSent: 'Η κάρτα εργασίας στάλθηκε στο email του υπαλλήλου.',
      workCardSendFailed: 'Η αποστολή της κάρτας εργασίας απέτυχε.',
    },
    validation: {
      ibanInvalidFormat: 'Το IBAN πρέπει να περιέχει μόνο λατινικούς χαρακτήρες και αριθμούς',
      ibanInvalid: 'Το IBAN δεν είναι έγκυρο',
      dateInvalid: 'Παρακαλώ εισάγετε έγκυρη ημερομηνία',
      dateRequired: 'Η ημερομηνία είναι υποχρεωτική',
      contractStartBeforeEnd: 'Η έναρξη σύμβασης πρέπει να προηγείται της λήξης',
      contractEndAfterStart: 'Η λήξη σύμβασης πρέπει να έπεται της αρχής',
      mobileRequired: 'Το κινητό είναι υποχρεωτικό',
      mobileInvalid: 'Το κινητό δεν είναι έγκυρο',
      firstNameRequired: 'Το όνομα είναι υποχρεωτικό',
      emailInvalid: 'Η διεύθυνση email δεν είναι έγκυρη',
      ssnInvalid: 'Το ΑΜΚΑ δεν είναι έγκυρο',
      ninInvalid: 'Το ΑΜΑ δεν είναι έγκυρο',
      tinInvalid: 'Το ΑΦΜ δεν είναι έγκυρο',
      additionalPhoneInvalid: 'Ο αριθμός σταθερού δεν είναι έγκυρος',
      phoneInUse: 'Ο αριθμός χρησιμοποιείται ήδη',
      numberInvalid: 'Παρακαλώ εισάγετε έναν έγκυρο αριθμό',
      hoursMin: 'Η ελάχιστη διάρκεια απασχόλησης είναι 1 ώρα',
      hoursMax: 'Η διάρκεια απασχόλησης δεν είναι έγκυρη',
      hoursRequired: 'Η διάρκεια απασχόλησης είναι υποχρεωτική',
      mobileInUse:
        'Το κινητό τηλέφωνο χρησιμοποιείται ήδη από τον υπάλληλο {{name}}. Μπορείτε να το χρησιμοποιήσετε ξανά με διαφορετικό όνομα, αλλά ΠΡΟΣΟΧΗ θα έχετε δύο ή περισσότερους υπαλλήλους με το ίδιο κινητό.',
    },
    schedule: {
      title: 'Πλάνο υπαλλήλου',
      sections: {
        current: 'Τρέχον πλάνο',
        future: 'Προγραμματισμένα πλάνα',
        past: 'Ιστορικό πλάνων',
        overrideHistory: 'Ιστορικό έκτακτων τροποποιήσεων',
        activeOverrides: 'Έκτακτες τροποποιήσεις',
        workHours: 'Ώρες εργασίας',
        breaks: 'Διάλειμμα',
        shift1: 'Ωράριο 1',
        shift2: 'Ωράριο 2',
      },
      empty: 'Δεν υπάρχει ενεργό πλάνο. Πατήστε "Νέο πλάνο" για να δημιουργήσετε ένα πλάνο.',
      fields: {
        title: 'Τίτλος:',
        titlePlaceholder: 'πχ. Μάιος 2025',
        startDate: 'Ημερομηνία έναρξης:',
        endDate: 'Ημερομηνία λήξης:',
        alternatingWeeks: 'Εναλλασσόμενα ωράρια',
        selectMode: 'Επιλέξτε',
        days: 'Μέρες',
      },
      modes: {
        sameHours: 'Ίδιες ώρες για κάθε μέρα',
        differentHours: 'Διαφορετικές ώρες για κάθε μέρα',
      },
      dayType: {
        working: 'Εργάσιμη',
        nonWorking: 'Μη εργάσιμη',
      },
      columns: {
        dayType: 'Είδος ημέρας',
        name: 'Τίτλος',
        planTitle: 'Τίτλος πλάνου',
        overrideDate: 'Ημ/νία',
        effectiveFrom: 'Ημερομηνία έναρξης',
        effectiveTo: 'Ημερομηνία λήξης',
      },
      currentItem: {
        startDate: 'Ημερομηνία έναρξης: <b>{{date}}</b>',
        endDate: 'Ημερομηνία λήξης: <b>{{date}}</b>',
      },
      overrideItem: {
        date: 'Ημ/νία: <b>{{date}}</b>',
      },
      actions: {
        planOverride: 'Έκτακτη τροποποίηση',
        newPlan: 'Νέο πλάνο',
        update: 'Ενημέρωση',
        addShift: 'Προσθήκη ωραρίου',
        addBreak: 'Προσθήκη διαλείμματος',
        editPlan: 'Τροποποίηση πλάνου',
        today: 'Σήμερα',
        saveAsDayOff: 'Αποθήκευση ως μη εργάσιμη',
      },
      snackbars: {
        created: 'Το πρόγραμμα αποθηκεύτηκε επιτυχώς!',
        createdPlanPending: 'Το πλάνο δημιουργήθηκε, αλλά η αποθήκευση ωραρίου απέτυχε. Δοκιμάστε ξανά με «Ενημέρωση».',
        updated: 'Το πρόγραμμα ενημερώθηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση του προγράμματος απέτυχε',
        overlap: 'Εντοπίστηκε αλληλοεπικάλυψη του προγράμματος με άλλο πρόγραμμα',
        devBypassConflict: 'Dev: ενημερώθηκε το υπάρχον επικαλυπτόμενο πλάνο (conflict bypass)',
        fetchFailed: 'Κάτι πήγε στραβά.',
      },
      deleteDialog: {
        title: 'Διαγραφή πλάνου',
        contentCurrent: 'Είστε σιγουροι ότι θέλετε να διαγράψετε το τρέχον πλάνο;',
        contentScheduled: 'Είστε σιγουροι ότι θέλετε να διαγράψετε αυτό το προγραμματισμένο πλάνο;',
        contentPast: 'Είστε σιγουροι ότι θέλετε να διαγράψετε αυτό το πλάνο από το ιστορικό;',
        contentOverride: 'Είστε σιγουροι ότι θέλετε να διαγράψετε αυτή την έκτακτη τροποποίηση;',
        cancel: 'Όχι ακόμα',
        confirm: 'Ναι, διαγραφή',
      },
      ergani: {
        sendButton: 'Αποστολή στην Εργάνη',
        sentChip: 'Σταλμένο στην Εργάνη',
        pendingChip: 'Δεν έχει αποσταλεί',
        sentAtTooltip: 'Στάλθηκε στις {{date}}',
        snackbars: {
          sendSuccess: 'Το εβδομαδιαίο πρόγραμμα αποστάλη στην ΕΡΓΑΝΗ επιτυχώς',
          sendFailed: 'Η αποστολή του εβδομαδιαίου προγράμματος στην ΕΡΓΑΝΗ απέτυχε',
        },
      },
      override: {
        title: 'Έκτακτη τροποποίηση',
        dateLabel: 'Ημερομηνία προς τροποποίηση:',
        dayOff: 'Η επιλεγμένη ημερομηνία είναι μη εργάσιμη για τον υπάλληλο.',
        tooltips: {
          addShift: 'Προσθήκη βάρδιας',
          deleteShift: 'Διαγραφή βάρδιας',
          addBreak: 'Προσθήκη διαλείμματος',
          deleteBreak: 'Διαγραφή διαλείμματος',
        },
        snackbars: {
          searchFailed: 'Η αναζήτηση της τροποποίησης απέτυχε',
          deleted: 'Η τροποποίηση διαγράφτηκε',
          deleteFailed: 'Η διαγραφή της τροποποίησης απέτυχε',
          saved: 'Η τροποποίηση αποθηκεύτηκε',
          saveFailed: 'Η αποθήκευση της τροποποίησης απέτυχε',
        },
        ergani: {
          sendButton: 'Αποστολή στην ΕΡΓΑΝΗ',
          sentChip: 'Σταλμένο στην Εργάνη',
          pendingChip: 'Εκκρεμεί αποστολή',
          snackbars: {
            sendSuccess: 'Η αποστολή στην ΕΡΓΑΝΗ ολοκληρώθηκε επιτυχώς',
            sendFailed: 'Η αποστολή στην ΕΡΓΑΝΗ απέτυχε',
            alreadySent: 'Η τροποποίηση έχει ήδη αποσταλεί στην ΕΡΓΑΝΗ',
          },
        },
      },
      overrideHistory: {
        snackbars: {
          fetchFailed: 'Η φόρτωση του ιστορικού έκτακτων τροποποιήσεων απέτυχε',
        },
      },
      validation: {
        startRequired: "Η ώρα 'από' είναι υποχρεωτικό πεδίο",
        endRequired: "Η ώρα 'εως' είναι υποχρεωτικό πεδίο",
        endAfterStart: "Η ώρα 'εως' πρέπει να είναι μεταγενέστερη της ώρας 'από'",
        nameRequired: 'Το όνομα του πλάνου είναι υποχρεωτικό',
        dateInvalid: 'Παρακαλώ εισάγετε έγκυρη ημερομηνία',
        dateRequired: 'Η ημερομηνία είναι υποχρεωτική',
        planStartBeforeEnd: 'Η έναρξη του πλάνου πρέπει να προηγείται της λήξης',
        planEndAfterStart: 'Η λήξη του πλάνου πρέπει να έπεται της αρχής',
      },
    },
    plan: {
      backToEdit: 'Επεξεργασία υπαλλήλου',
      notFound: 'Το πρόγραμμα δεν βρέθηκε',
      legend: {
        work: 'Εργάσιμες ώρες',
        break: 'Διαλείμματα',
        today: 'Τρέχουσα ημέρα',
      },
    },
  },
  ergani: {
    employees: {
      title: 'Υπάλληλοι Εργάνης',
      sendButton: 'Αποστολή στην Εργάνη',
      sending: 'Αποστολή...',
      selected_one: 'Επιλεγμένος',
      selected_other: 'Επιλεγμένοι',
      columns: {
        scheduleStatus: 'Ωράριο σε Εργάνη',
      },
      status: {
        sent: 'Έχει αποσταλεί',
        pending: 'Δεν έχει αποσταλεί',
      },
      snackbars: {
        fetchFailed: 'Σφάλμα κατά τη φόρτωση υπαλλήλων',
        sendSuccess: 'Το εβδομαδιαίο πρόγραμμα αποστάλη στην ΕΡΓΑΝΗ επιτυχώς',
        sendFailed: 'Σφάλμα κατά την αποστολή στην ΕΡΓΑΝΗ',
        endpointUnavailable: 'Το endpoint δεν είναι ακόμα διαθέσιμο. Επικοινωνήστε με την ομάδα backend.',
        nothingToSend: 'Δεν υπάρχουν εκκρεμή προγράμματα προς αποστολή',
        bulkSendSuccess_one: '{{count}} πρόγραμμα αποστάλθηκε στην ΕΡΓΑΝΗ επιτυχώς',
        bulkSendSuccess_other: '{{count}} προγράμματα αποστάλθηκαν στην ΕΡΓΑΝΗ επιτυχώς',
        noScheduleForEmployee: '{{name}}: δεν υπάρχει ενεργό πλάνο προς αποστολή',
        sendFailedForEmployee: '{{name}}: σφάλμα κατά την αποστολή του προγράμματος στην ΕΡΓΑΝΗ',
      },
      attendanceButton: 'Στοιχεία προσέλευσης/αποχώρησης',
      dayTimesAria: 'Στοιχεία προσέλευσης/αποχώρησης',
    },
    attendance: {
      title: 'Στοιχεία προσέλευσης/αποχώρησης',
      scheduledHours: 'Ωράριο ΕΡΓΑΝΗ',
      checkIn: 'Προσέλευση',
      checkOut: 'Αποχώρηση',
      nonWorking: 'Μη εργάσιμη',
      emptyDay: 'Δεν υπάρχει ωράριο ούτε καταχωρημένες κινήσεις για αυτή την ημέρα.',
      noSchedule: 'Δεν υπάρχει ωράριο για αυτή την ημέρα.',
      noEmployees: 'Δεν βρέθηκαν υπάλληλοι Εργάνης στο επιλεγμένο υποκατάστημα.',
      deviationWarning: 'Απόκλιση μεγαλύτερη των 15 λεπτών από το δηλωμένο ωράριο',
      onTime: 'Εντός 15 λεπτών από το δηλωμένο ωράριο',
      today: 'Σήμερα',
      previousDay: 'Προηγούμενη ημέρα',
      nextDay: 'Επόμενη ημέρα',
      previousWeek: 'Προηγούμενη εβδομάδα',
      nextWeek: 'Επόμενη εβδομάδα',
      fetchFailed: 'Σφάλμα κατά τη φόρτωση των στοιχείων προσέλευσης/αποχώρησης',
    },
  },
  workCard: {
    title: 'Κάρτα Εργασίας',
    subtitle: 'Παρακαλούμε εισάγετε την προσέλευση ή την αποχώρηση ενός υπαλλήλου.',
    headerButton: 'Σάρωση κάρτας εργασίας',
    resendInfo:
      'Αν κάποιος υπάλληλος δεν έχει πρόσβαση στον QR κωδικό του, μπορεί να γίνει επαναποστολή αυτού στο email του, πηγαίνοντας στην καρτέλα του, στα "Στοιχεία εργασίας" και πατώντας το κουμπί "Αποστολή κάρτας εργασίας".',
    goToEmployees: 'Μεταφορά στην λίστα υπαλλήλων',
    actions: {
      scanQr: 'Σάρωση QR κωδικού',
      manualEntry: 'Χειροκίνητη εισαγωγή',
      checkIn: 'Προσέλευση',
      checkOut: 'Αποχώρηση',
      dismiss: 'Ακύρωσε',
    },
    scanner: {
      title: 'Σάρωση κάρτας εργασίας',
      starting: 'Ενεργοποίηση κάμερας...',
      startingHint: 'Αν εμφανιστεί αίτημα άδειας, πάτα «Να επιτρέπεται». Κοίτα και το εικονίδιο κάμερας δίπλα στη διεύθυνση του browser.',
      hint: 'Στρέψτε την κάμερα στον QR κωδικό της κάρτας εργασίας του υπαλλήλου.',
      retry: 'Δοκιμάστε ξανά',
      errors: {
        noCamera: 'Δεν βρέθηκε κάμερα σε αυτή τη συσκευή.',
        permissionDenied:
          'Δεν δόθηκε άδεια χρήσης της κάμερας. Επιτρέψτε την πρόσβαση στην κάμερα από τις ρυθμίσεις του browser και δοκιμάστε ξανά.',
        generic: 'Δεν ήταν δυνατή η ενεργοποίηση της κάμερας.',
      },
    },
    scanResult: {
      title: 'Επιτυχής σάρωση',
      subtitle: 'Επιλέξτε αν η σάρωση ήταν για Προσέλευση ή Αποχώρηση',
      employee: 'Όνομα υπαλλήλου',
      time: 'Ώρα σάρωσης',
    },
    manual: {
      title: 'Προσέλευση / Αποχώρηση Υπαλλήλου',
      noEmployees: 'Δεν βρέθηκαν υπάλληλοι Εργάνης',
      fields: {
        employee: 'Υπάλληλος',
        employeePlaceholder: 'Επιλέξτε υπάλληλο',
        employeeHelper: 'Αναζητήστε τον υπάλληλο μέσω ονοματεπώνυμου, ΑΦΜ ή κινητού τηλεφώνου',
        date: 'Ημερομηνία',
        time: 'Ώρα',
      },
      validation: {
        employeeRequired: 'Επιλέξτε υπάλληλο',
        dateRequired: 'Η ημερομηνία είναι υποχρεωτική',
        dateInvalid: 'Μη έγκυρη ημερομηνία',
        timeRequired: 'Η ώρα είναι υποχρεωτική',
        timeInvalid: 'Μη έγκυρη ώρα',
        notInFuture: 'Η ώρα δεν μπορεί να είναι μελλοντική',
      },
    },
    snackbars: {
      checkInSaved: 'Η προσέλευση αποθηκεύτηκε με επιτυχία!',
      checkOutSaved: 'Η αποχώρηση αποθηκεύτηκε με επιτυχία!',
    },
    errors: {
      saveFailed: 'Η καταχώρηση στην ΕΡΓΑΝΗ απέτυχε. Δοκιμάστε ξανά.',
      noBranchSelected: 'Επιλέξτε υποκατάστημα για να καταχωρήσετε προσέλευση / αποχώρηση.',
      employeesLoadFailed: 'Σφάλμα κατά τη φόρτωση των υπαλλήλων Εργάνης.',
      employeesStillLoading: 'Οι υπάλληλοι φορτώνονται ακόμα, δοκιμάστε ξανά σε λίγο.',
      invalidQr: 'Ο QR κωδικός δεν είναι κάρτα εργασίας.',
      unknownEmployee: 'Ο QR κωδικός δεν αντιστοιχεί σε υπάλληλο Εργάνης του επιλεγμένου υποκαταστήματος.',
      employeeNotFound: 'Ο υπάλληλος δεν βρέθηκε.',
      BRANCH_NOT_ASSOCIATED:
        'Το υποκατάστημα δεν έχει συνδεθεί με παράρτημα της ΕΡΓΑΝΗ. Ολοκληρώστε τη σύνδεση από τις Ρυθμίσεις > ΕΡΓΑΝΗ.',
      EMPLOYEE_TAX_ID_MISSING: 'Ο υπάλληλος δεν έχει ΑΦΜ. Συμπληρώστε το στην καρτέλα του υπαλλήλου.',
      EMPLOYEE_LAST_NAME_MISSING: 'Ο υπάλληλος δεν έχει επώνυμο. Συμπληρώστε το στην καρτέλα του υπαλλήλου.',
      EMPLOYEE_NOT_IN_ERGANI: 'Ο υπάλληλος δεν είναι δηλωμένος στην ΕΡΓΑΝΗ.',
      EMPLOYEE_EMAIL_MISSING: 'Ο υπάλληλος δεν έχει email. Συμπληρώστε το στην καρτέλα του.',
      ATTENDANCE_NOT_ALTERNATING:
        'Η κίνηση δεν είναι συνεπής με την τελευταία καταχώρηση του υπαλλήλου (μετά από προσέλευση πρέπει να ακολουθεί αποχώρηση και αντίστροφα).',
    },
  },
  services: {
    listTitle: 'Υπηρεσίες',
    addService: 'Δημιουργία υπηρεσίας',
    reorderTitle: 'Αλλαγή σειράς εμφάνισης',
    available: 'Διαθέσιμη',
    unavailable: 'Μη διαθέσιμη',
    active: 'Ενεργή',
    inactive: 'Ανενεργή',
    minute: 'λεπτό',
    minutes: 'λεπτά',
    cannotDisableLastActive: 'Δεν μπορεί να απενεργοποιηθεί η μοναδική ενεργή υπηρεσία της ειδικότητας',
    createTitle: 'Δημιουργία υπηρεσίας',
    backToList: 'Λίστα υπηρεσιών',
    columns: {
      name: 'Όνομα',
      code: 'Κωδικός',
      netAmount: 'Αξία χωρίς Φ.Π.Α.',
      vatPercentage: 'Κατηγορία Φ.Π.Α.',
      grossAmount: 'Τελική αξία',
      duration: 'Διάρκεια',
      status: 'Κατάσταση',
    },
    sections: {
      basicInfo: 'Βασικές πληροφορίες',
      amount: 'Αξία',
      duration: 'Διάρκεια',
      publicBooking: 'Online κρατήσεις',
    },
    fields: {
      name: 'Όνομα',
      category: 'Κατηγορία',
      status: 'Κατάσταση',
      netAmount: 'Αξία χωρίς Φ.Π.Α.',
      grossAmount: 'Αξία με Φ.Π.Α.',
      vatPercentage: 'Κατηγορία Φ.Π.Α. (%)',
      durationInMinutes: 'Διάρκεια υπηρεσίας (λεπτά)',
      preparationDurationInMinutes: 'Διάρκεια προετοιμασίας (λεπτά)',
      overlapAvailabilityDurationInMinutes: 'Χρόνος επικάλυψης διαθεσιμότητας (λεπτά)',
      bufferDurationInMinutes: 'Έξτρα χρόνος υπηρεσίας (λεπτά)',
      offeredForPublicBooking: 'Διαθέσιμη στις online κρατήσεις',
      comments: 'Παρατηρήσεις',
    },
    placeholders: {
      durationServiceExample: 'π.χ. 120',
      durationOtherExample: 'π.χ. 10',
    },
    tooltips: {
      durationService: 'Χρόνος που απαιτεί η διαδικασία σε λεπτά',
      preparation: 'Απαιτούμενος Χρόνος Προετοιμασίας πριν την έναρξη της διαδικασίας σε λεπτά',
      overlap: 'Χρόνος Παράλληλης Εξυπηρέτησης Πελατών σε λεπτά',
      buffer: 'Χρόνος Αναμονής Πελάτη σε λεπτά',
    },
    snackbars: {
      saved: 'Η υπηρεσία αποθηκεύτηκε επιτυχώς!',
      saveFailed: 'Η αποθήκευση της υπηρεσίας απέτυχε',
      notFound: 'Η υπηρεσία δεν βρέθηκε',
      reorderSuccess: 'Η σειρά ενημερώθηκε επιτυχώς',
    },
    validation: {
      nameRequired: 'Το όνομα της υπηρεσίας είναι υποχρεωτικό',
      vatInvalid: 'Η τιμή που επιλέξατε δεν είναι μέσα στις επιτρεπτές τιμές.',
      vatRequired: 'Το ποσοστό Φ.Π.Α. είναι υποχρεωτικό',
      durationPositive: 'Δεν επιτρέπεται αρνητική διάρκεια',
      durationMin: 'Η διάρκεια υπηρεσίας πρέπει να είναι τουλάχιστον 1 λεπτό',
      durationRequired: 'Η διάρκεια υπηρεσίας είναι υποχρεωτική',
      prepDurationMin: 'Η διάρκεια προετοιμασίας πρέπει να είναι τουλάχιστον 1 λεπτό',
      overlapMin: 'Τα λεπτά επικάλυψης πρέπει να είναι τουλάχιστον 1',
      bufferMin: 'Ο χρόνος αναμονής πρέπει να είναι τουλάχιστον 1 λεπτό',
    },
    reorder: {
      title: 'Αλλαγή σειράς εμφάνισης υπηρεσιών',
      description:
        'Προσαρμόστε τη σειρά εμφάνισης των υπηρεσιών στη σελίδα online κρατήσεων. Οι αλλαγές αποθηκεύονται αυτόματα και εφαρμόζονται άμεσα.',
      empty: 'Δεν υπάρχουν ακόμη καταχωρημένες υπηρεσίες',
    },
  },
  orders: {
    listTitle: 'Παραγγελίες',
    createOrder: 'Δημιουργία παραγγελίας',
    backToList: 'Λίστα Παραγγελιών',
    title: 'Παραγγελία',
    statusLabel: 'Κατάσταση παραγγελίας:',
    completeButton: 'Ολοκλήρωση',
    columns: {
      orderNumber: 'Αρ. παραγγελίας',
      createdAt: 'Ημ. δημιουργίας',
      lead: 'Lead',
      company: 'Εταιρεία',
      leadManager: 'Υπάλληλος (Lead Manager)',
      participants: 'Συμμετέχοντες',
      totalAmount: 'Αξία με ΦΠΑ',
      status: 'Κατάσταση παραγγελίας',
    },
    clone: {
      title: 'Αντιγραφή παραγγελίας',
      content: 'Θέλετε να αντιγράψετε την παραγγελία {{orderId}}?',
      success: 'Η παραγγελία {{orderId}} αντιγράφηκε επιτυχώς',
    },
    totals: {
      label: 'Σύνολο (με ΦΠΑ)',
      error: 'Αδυναμία φόρτωσης συνόλου',
    },
    create: {
      title: 'Δημιουργία παραγγελίας',
      branch: 'Επιλογή υποκαταστήματος',
      allBranches: 'Όλα τα υποκαταστήματα',
      searchAccordion: 'Αναζήτηση επαφής{{ companyPart }}',
      companyPart: '/εταιρείας',
      contact: 'Επαφή',
      newContact: 'Δημιουργία νέας επαφής',
      mobilePhone: 'Κινητό τηλέφωνο',
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      companyOrder: 'Εταιρική παραγγελία',
      contactCompany: 'Εταιρεία επαφής',
      snackbars: {
        contactExists: 'Η επαφή υπάρχει ήδη',
        contactCreateFailed: 'Η δημιουργία επαφής απέτυχε',
        saveFailed: 'Η αποθήκευση της παραγγελίας απέτυχε',
      },
    },
    sections: {
      basicInfo: 'Βασικές πληροφορίες',
      items: 'Είδη',
      payments: 'Πληρωμές',
      otherInfo: 'Λοιπές πληροφορίες',
    },
    fields: {
      client: 'Πελάτης',
      company: 'Εταιρεία',
      effectiveFrom: 'Ημερομηνία δημιουργίας',
      expiresOn: 'Ημερομηνία λήξης',
      leadManager: 'Υπάλληλος (Lead Manager)',
      participants: 'Συμμετέχοντες',
      notes: 'Παρατηρήσεις',
      paymentMethod: 'Τρόπος πληρωμής:',
      totalDiscountAmount: 'Τελική έκπτωση (€):',
      totalDiscountPercentage: 'Τελική έκπτωση (%):',
      totalAmount: 'Τελικό σύνολο:',
    },
    items: {
      service: 'Υπηρεσία',
      netAmount: 'Αξία χωρίς ΦΠΑ',
      vat: 'ΦΠΑ',
      discountAmount: 'Έκπτωση €',
      discountPercentage: 'Έκπτωση %',
      total: 'Σύνολο',
    },
    payments: {
      emptyState: 'Προσθέστε είδη και θα δημιουργηθεί το πλάνο πληρωμών',
      title: 'Πληρωμή {{number}}',
      dueBy: 'Εξόφληση έως:',
      method: 'Τρόπος πληρωμής:',
      total: 'Σύνολο',
      edit: 'Επεξεργασία πληρωμής',
      editTitle: 'Επεξεργασία πληρωμής {{number}}',
      fields: {
        paymentMethod: 'Τρόπος πληρωμής',
        dueDate: 'Εξόφληση έως',
      },
      methodDisabled: 'Ανενεργό',
      validation: {
        methodRequired: 'Ο τρόπος πληρωμής είναι υποχρεωτικός',
        dueDateRequired: 'Η ημερομηνία εξόφλησης είναι υποχρεωτική',
      },
      updateSuccess: 'Η πληρωμή ενημερώθηκε',
    },
    selectPaymentMethod: 'Επιλέξτε τρόπο πληρωμής',
    snackbars: {
      updated: 'Η παραγγελία ενημερώθηκε',
      itemAdded: 'Η υπηρεσία προστέθηκε',
      itemDeleted: 'Η υπηρεσία διαγράφηκε',
      saveFailed: 'Η αποθήκευση της παραγγελίας απέτυχε',
      genericFail: 'Κάτι πήγε στραβά.',
      notFound: 'Η παραγγελία δεν βρέθηκε',
      invoiceCancelled: 'Το παραστατικό ακυρώθηκε',
      invoiceCancelledAtAade: 'Το παραστατικό ακυρώθηκε στην ΑΑΔΕ',
      draftDiscarded: 'Το προσχέδιο καταργήθηκε',
      invoiceIssued: 'Το παραστατικό εκδόθηκε',
      invoiceRejected: 'Η ΑΑΔΕ απέρριψε το παραστατικό',
      invoiceUnconfirmed: 'Η ΑΑΔΕ δεν επιβεβαίωσε την έκδοση. Δοκιμάστε ξανά.',
      invoiceFoundCancelled: 'Το παραστατικό βρέθηκε ήδη ακυρωμένο στην ΑΑΔΕ.',
    },
    delete: {
      title: 'Διαγραφή παραγγελίας',
      content: 'Θέλετε να διαγράψετε την παραγγελία #{{orderId}}?',
    },
    completeStatus: {
      title: 'Ολοκλήρωση παραγγελίας',
      content:
        'Με την ολοκλήρωση της παραγγελίας, θα μπορείτε να διαχειριστείτε μόνο τα τιμολόγια. Είστε σίγουροι ότι θέλετε να συνεχίσετε;',
      confirmButton: 'Ναι, ολοκλήρωση',
      cancelButton: 'Όχι ακόμα',
    },
    invoicePrint: {
      invoiceTitle: 'Τιμολογιο Παροχης Υπηρεσιων',
      receiptTitle: 'Αποδειξη Παροχης Υπηρεσιων',
      titles: {
        SERVICE_RECEIPT: 'Αποδειξη Παροχης Υπηρεσιων',
        RETAIL_CREDIT_NOTE: 'Πιστωτικο Στοιχειο Λιανικης',
        SERVICE_INVOICE: 'Τιμολογιο Παροχης Υπηρεσιων',
        SERVICE_CREDIT_INVOICE: 'Πιστωτικο Τιμολογιο',
      },
      number: 'Αριθμος',
      noNumber: 'Χωρις αριθμο',
      draftWatermark: 'ΠΡΟΣΧΕΔΙΟ / ΜΗ ΕΓΚΥΡΟ',
      statuses: {
        DRAFT: 'Προχειρο',
        PENDING: 'Εκκρεμει',
        ISSUED: 'Εκδοθηκε',
        FAILED: 'Απορριφθηκε',
        CANCELLED: 'Ακυρωθηκε',
        REVERSED: 'Πιστωθηκε',
        DISCARDED: 'Καταργηθηκε',
      },
      missingCompany: 'Δεν έχει συνδεθεί εταιρεία',
      noSeries: 'Χωρίς σειρά',
      vatNumber: 'ΑΦΜ',
      invoiceDetails: 'Στοιχεια τιμολογιου',
      receiptDetails: 'Στοιχεια αποδειξης',
      customerDetails: 'Στοιχεια πελατη',
      date: 'Ημερομηνία',
      dueDate: 'Ημερομηνία εξόφλησης',
      paymentMethod: 'Τρόπος πληρωμής',
      finalTotal: 'Τελικό Σύνολο',
      columns: {
        service: 'Υπηρεσία',
        valueBeforeDiscount: 'Αξία προ Έκπτωσης',
        netAmount: 'Καθαρή Αξία',
        vat: 'ΦΠΑ',
        discount: 'Έκπτωση',
        total: 'Σύνολο',
      },
      myData: {
        title: 'Διασυνδεση με myDATA',
        mark: 'ΜΑΡΚ',
        uid: 'UID παραστατικού',
        authenticationCode: 'Κωδικός αυθεντικοποίησης',
      },
    },
    validation: {
      totalDiscountRequired: 'Η συνολική έκπτωση είναι υποχρεωτική',
      totalAmountRequired: 'Το συνολικό ποσό είναι υποχρεωτικό',
      currencyInvalid: 'Η τιμή που επιλέξατε δεν είναι μέσα στις επιτρεπτές τιμές.',
      serviceRequired: 'Η υπηρεσία είναι υποχρεωτική',
      netAmountRequired: 'Η Αξία χωρίς ΦΠΑ είναι υποχρεωτική',
      vatPercentageRequired: 'Η Κατηγορία ΦΠΑ είναι υποχρεωτική',
      itemTotalRequired: 'Το σύνολο είναι υποχρεωτικό',
      statusRequired: 'Η κατάσταση της παραγγελίας είναι υποχρεωτική',
      effectiveFromRequired: 'Η ημερομηνία δημιουργίας είναι υποχρεωτική',
      clientRequired: 'Η επιλογή πελάτη είναι υποχρεωτική',
      atLeastOneItem: 'Η παραγγελία πρέπει να έχει τουλάχιστον μια υπηρεσία',
      mobileRequired: 'Το κινητό είναι υποχρεωτικό',
      mobileInvalid: 'Το κινητό δεν είναι έγκυρο',
      amountRequired: 'Το ποσό είναι υποχρεωτικό',
      amountValueRequired: 'Το ποσό είναι υποχρεωτικό',
      amountTypeRequired: 'Ο τύπος ποσού είναι υποχρεωτικός',
      discountRequired: 'Η έκπτωση είναι υποχρεωτική',
      discountTypeRequired: 'Ο τύπος έκπτωσης είναι υποχρεωτικός',
      discountAmountMin: 'Η έκπτωση δεν πρέπει να είναι μικρότερη από {{min}}€',
      discountAmountMax: 'Η έκπτωση δεν πρέπει να ξεπερνά τα {{max}}€',
      discountPercentageMin: 'Η έκπτωση δεν πρέπει να είναι μικρότερη από {{min}}%',
      discountPercentageMax: 'Η έκπτωση δεν πρέπει να ξεπερνά το {{max}}%',
      vatPercentagePositive: 'Η κατηγορία ΦΠΑ πρέπει να είναι μεγαλύτερη από 0',
      vatPercentageInteger: 'Η κατηγορία ΦΠΑ πρέπει να είναι ακέραιος αριθμός',
      grossTotalPositive: 'Το σύνολο πρέπει να είναι μεγαλύτερο από 0',
      grossTotalMax: 'Το σύνολο δεν πρέπει να ξεπερνά τα {{max}}€',
    },
    drawer: {
      title: 'Παραστατικά για {{invoiceName}}',
      subtitle: {
        active: 'Ενεργό παραστατικό',
        previous: 'Προηγούμενα παραστατικά',
      },
      fields: {
        status: 'Κατάσταση',
        sequence: {
          label: 'Σειρά αρίθμησης',
          emptyState: 'Επιλέξτε σειρά αρίθμησης',
        },
        dueDate: 'Ημερομηνία',
        issuedDate: 'Ημερομηνία έκδοσης',
      },
      viewDraft: 'Εμφάνιση προσχεδίου',
      previewTitle: 'Προεπισκόπηση',
      printPreview: 'Εκτύπωση',
      noInvoiceSeries:
        'Δεν έχετε δημιουργήσει ακόμα κάποια σειρά αρίθμησης. Μπορείτε να δημιουργήσετε μια πατώντας το μωβ κουμπί ρυθμίσεων στα δεξιά.',
      invoiceLoadFailed:
        'Δεν ήταν δυνατή η φόρτωση των παραστατικών. Οι ενέργειες τιμολόγησης δεν είναι διαθέσιμες μέχρι να δοκιμάσετε ξανά.',
      noB2bSeries:
        'Τα τιμολόγια προς επιχειρήσεις εκδίδονται μέσω του παρόχου ηλεκτρονικής τιμολόγησης, που δεν είναι ακόμα διαθέσιμος. Το προσχέδιο παραμένει και μπορεί να εκδοθεί αργότερα.',
      aadeNotConnected:
        'Η επιχείρηση δεν έχει στοιχεία σύνδεσης myΑΑΔΕ. Προσθέστε τα από τις ρυθμίσεις τιμολογίων πριν εκδώσετε παραστατικά.',
      goToInvoicingSettings: 'Μεταφορά στις ρυθμίσεις τιμολογίων',
      noDraft: {
        description:
          'Δεν υπάρχει ακόμα παραστατικό για αυτή την πληρωμή. Δημιουργήστε προσχέδιο για να επιλέξετε σειρά και να το εκδώσετε.',
        create: 'Δημιουργία προσχεδίου',
      },
      generateInvoice: 'Έκδοση παραστατικού',
      viewInvoice: 'Προβολή',
      manageInvoices: 'Διαχείριση παραστατικών',
      invoicesDisabledNotCompleted: 'Τα παραστατικά είναι διαθέσιμα μόνο σε ολοκληρωμένες παραγγελίες',
      cancelInvoice: 'Ακύρωση',
      discardDraft: 'Απόρριψη προσχεδίου',
      confirmIssuance: 'Επιβεβαίωση έκδοσης',
      retryIssuance: 'Νέα προσπάθεια έκδοσης',
      awaitingMark: 'Εκκρεμεί ΜΑΡΚ',
      confirmations: {
        issue: {
          title: 'Έκδοση παραστατικού',
          content:
            'Είστε βέβαιοι ότι θέλετε να εκδώσετε το παραστατικό; Θα πάρει αριθμό και θα διαβιβαστεί στην ΑΑΔΕ ως νόμιμο παραστατικό, οπότε δεν θα επιτρέπονται αλλαγές. Ο τρόπος πληρωμής & η ημερομηνία εξόφλησης θα τυπωθούν στο παραστατικό.',
          confirm: 'Έκδοση παραστατικού',
          cancel: 'Να μην εκδοθεί',
        },
        cancel: {
          title: 'Ακύρωση παραστατικού',
          content: 'Είστε βέβαιοι ότι θέλετε να ακυρώσετε το παραστατικό; Η ακύρωση διαβιβάζεται στην ΑΑΔΕ.',
          confirm: 'Ακύρωση παραστατικού',
          cancel: 'Να μην ακυρωθεί',
        },
        cancelFailed: {
          title: 'Ακύρωση παραστατικού',
          content:
            'Το παραστατικό δεν υπάρχει στην ΑΑΔΕ. Η ακύρωση αποδεσμεύει την πληρωμή, ώστε να εκδοθεί νέο παραστατικό· ο αριθμός του μένει αχρησιμοποίητος.',
          confirm: 'Ακύρωση παραστατικού',
          cancel: 'Να μην ακυρωθεί',
        },
        cancelPending: {
          title: 'Ακύρωση παραστατικού',
          content:
            'Θα ελεγχθεί πρώτα στην ΑΑΔΕ αν το παραστατικό καταχωρίστηκε. Αν ναι, θα ακυρωθεί στην ΑΑΔΕ· αλλιώς θα ακυρωθεί εδώ και ο αριθμός του θα μείνει αχρησιμοποίητος.',
          confirm: 'Ακύρωση παραστατικού',
          cancel: 'Να μην ακυρωθεί',
        },
        discard: {
          title: 'Απόρριψη προσχεδίου',
          content: 'Το προσχέδιο θα καταργηθεί. Δεν έχει πάρει αριθμό, οπότε η αρίθμηση δεν επηρεάζεται.',
          confirm: 'Απόρριψη προσχεδίου',
          cancel: 'Να μην απορριφθεί',
        },
      },
      pendingInvoice: {
        notice:
          'Η ΑΑΔΕ δεν επιβεβαίωσε την τελευταία διαβίβαση. Η «Επιβεβαίωση έκδοσης» ελέγχει το παραστατικό στην ΑΑΔΕ και ολοκληρώνει την έκδοσή του.',
      },
      failedInvoice: {
        title: 'Η ΑΑΔΕ απέρριψε το παραστατικό',
        cancelHint: 'Αν δεν μπορεί να διορθωθεί, ακυρώστε το: η πληρωμή αποδεσμεύεται και ο αριθμός μένει αχρησιμοποίητος.',
      },
      issuedInvoice: {
        notice: 'Εκδόθηκε και διαβιβάστηκε στην ΑΑΔΕ (myDATA)',
      },
      cancelledInvoice: {
        issuedDate: 'Εκδόθηκε',
        cancelledDate: 'Ακυρώθηκε',
        discardedDate: 'Καταργήθηκε',
        aadeCancellationMark: 'MARK ακύρωσης ΑΑΔΕ',
      },
      errors: {
        outcomeUnconfirmed: 'Δεν λάβαμε επιβεβαίωση για το αποτέλεσμα. Η προβολή ανανεώθηκε με την τρέχουσα κατάσταση του παραστατικού.',
        aadeCredentialsMissing:
          'Η επιχείρηση του παραστατικού δεν έχει στοιχεία σύνδεσης myΑΑΔΕ. Προσθέστε τα από τις ρυθμίσεις τιμολογίων και δοκιμάστε ξανά.',
      },
    },
  },
  bookings: {
    calendarTitle: 'Ημερολόγιο',
    listTitle: 'Ραντεβού',
    backToCalendar: 'Ημερολόγιο',
    columns: {
      contact: 'Πελάτης',
      dateTime: 'Ημερομηνία/Ώρα',
      service: 'Υπηρεσία',
      amount: 'Αξία',
      employee: 'Υπάλληλος',
      status: 'Κατάσταση ραντεβού',
    },
    delete: {
      title: 'Διαγραφή παραγγελίας',
      content: 'Θέλετε να διαγράψετε το ραντεβού {{bookingId}}?',
    },
    toolbar: {
      list: 'Λίστα ραντεβού',
      newBooking: 'Νέο ραντεβού',
      today: 'Σήμερα',
      filters: 'Φίλτρα',
      filtersLabel: 'Φίλτρα:',
      filtersTitle: 'Φίλτρα ραντεβού',
      apply: 'Εφαρμογή',
      filterChip: {
        contact: 'Πελάτης: {{name}}',
        service: 'Υπηρεσία: {{name}}',
        status: 'Κατάσταση: {{name}}',
      },
    },
    drawer: {
      service: 'Υπηρεσία',
      contact: 'Πελάτης',
      status: 'Κατάσταση ραντεβού',
    },
    validation: {
      dateRequired: 'Η ημερομηνία είναι υποχρεωτική',
      timeRequired: 'Η ώρα είναι υποχρεωτική',
      employeeRequired: 'Η επιλογή υπαλλήλου είναι υποχρεωτική',
      firstNameRequired: 'Το όνομα είναι υποχρεωτικό',
      mobileRequired: 'Το κινητό είναι υποχρεωτικό',
      mobileInvalid: 'Το κινητό δεν είναι έγκυρο',
      emailRequired: 'Το email πελάτη είναι υποχρεωτικό',
      emailInvalid: 'Η διεύθυνση email δεν είναι έγκυρη',
      serviceRequired: 'Η επιλογή υπηρεσίας είναι υποχρεωτική',
    },
    snackbars: {
      created: 'Το ραντεβού δημιουργήθηκε',
      updated: 'Το ραντεβού ενημερώθηκε',
      deleted: 'Το ραντεβού διαγράφηκε',
      saved: 'Το ραντεβού αποθηκεύτηκε.',
      cancelled: 'Το ραντεβού ακυρώθηκε.',
      saveFailed: 'Κάτι πήγε στραβά.',
      notFound: 'Η κράτηση δεν βρέθηκε',
      mobileCheckFailed: 'Κάτι πήγε στραβά κατά τον έλεγχο του κινητού',
      contactCreateFailed: 'Η δημιουργία επαφής απέτυχε',
      pickContactWarning: 'Επιλέξτε υπάρχουσα επαφή ή δημιουργήστε νέα.',
    },
    form: {
      backToList: 'Λίστα Ραντεβού',
      titleEdit: 'Επεξεργασία Ραντεβού',
      titleNew: 'Νέο Ραντεβού',
      statusPlaceholder: 'Κατάσταση ραντεβού',
      statusLabel: 'Κατάσταση ραντεβού',
      completedAlert: 'To ραντεβού είναι ολοκληρωμένο. Για να το επεξεργαστείτε θα πρέπει να αλλάξετε το status της συνδεδεμένης',
      completedAlertLink: 'παραγγελίας',
      date: 'Ημερομηνία',
      time: 'Ώρα',
      employee: 'Υπάλληλος',
      service: 'Υπηρεσία',
      comments: 'Σχόλια',
      searchExistingContact: 'Αναζήτηση υπάρχουσας επαφής',
      newContactSection: 'Δημιουργία νέας επαφής',
      mobilePhone: 'Κινητό τηλέφωνο',
      firstName: 'Όνομα',
      lastName: 'Επώνυμο',
      email: 'Email',
      clientEmail: 'Email πελάτη',
      notifyClient: 'Ειδοποίηση πελάτη',
      notifyClientTooltip:
        "Αν ενεργοποιήσετε την ειδοποίηση πελάτη, κατά την μετάβαση του ραντεβου στην κατάσταση 'Σε Ισχύ' ή κατά την ακύρωση, θα αποσταλεί email με τις λεπτομέρειες του ραντεβού στον πελάτη.",
      save: 'Αποθήκευση',
      create: 'Δημιουργία',
      cancelButton: 'Ακύρωση',
      cancelBooking: 'Ακύρωση ραντεβού',
      cancelDialogTitle: 'Ακύρωση ραντεβού',
      cancelDialogContent: 'Θέλετε σίγουρα να ακυρώσετε αυτό το ραντεβού;',
      clientReminders: {
        title: 'Καταγραφή υπενθυμίσεων αυτού του πελάτη',
        loading: 'Φόρτωση της καταγραφής υπενθυμίσεων…',
        unavailable: 'Δεν ήταν δυνατή η φόρτωση της καταγραφής υπενθυμίσεων αυτού του πελάτη.',
        smsOn: 'Υπενθυμίσεις SMS: ενεργές',
        smsOff: 'Υπενθυμίσεις SMS: ανενεργές — ο πελάτης ζήτησε να σταματήσουν',
        emailOn: 'Υπενθυμίσεις email: ενεργές',
        emailOff: 'Υπενθυμίσεις email: ανενεργές — ο πελάτης ζήτησε να σταματήσουν',
        confirmationsNote: 'Η καταγραφή αυτή δεν επηρεάζει τα email επιβεβαίωσης ή ακύρωσης του ραντεβού.',
        permanenceNote: 'Κάθε αλλαγή σε αυτή την καταγραφή καταγράφεται μόνιμα με το όνομα του χρήστη που την πραγματοποιεί.',
        changeLink: 'Άνοιγμα καρτέλας πελάτη για αλλαγή',
      },
    },
  },
  statistics: {
    title: 'Στατιστικά',
    totalRevenue: 'Συνολικός Τζίρος',
    monthlyRevenue: 'Μηνιαίος Τζίρος',
    compareLastYear: 'Σε σχέση με πέρσι το ίδιο διάστημα',
    noData: 'Δεν υπάρχουν δεδομένα',
    revenueByMonth: 'Τζίρος ανά Μήνα',
    revenueByService: 'Τζίρος ανά Υπηρεσία',
    revenueByServiceCategory: 'Τζίρος ανά Κατηγορία Υπηρεσιών',
    revenueByEmployee: 'Τζίρος ανά Υπάλληλο',
    revenueByEmployeeService: 'Τζίρος ανά Υπάλληλο ανά Υπηρεσία',
    completedOnlyTooltip: 'Μόνο για ολοκληρωμένες παραγγελίες',
    dateRange: {
      start: 'Από',
      end: 'Έως',
    },
  },
  dashboard: {
    listTitle: 'Επισκόπηση',
    period: {
      label: 'Χρονική περίοδος',
      last7: 'Τελευταίες 7 ημέρες',
      last30: 'Τελευταίες 30 ημέρες',
      last365: 'Τελευταίες 365 ημέρες',
    },
    activeClients: {
      title: 'Ενεργοί Πελάτες',
      tooltip: 'Οι πελάτες σας που έχουν ολοκληρωμένες παραγγελίες',
    },
    noShow: {
      title: 'No Show Ratio',
      tooltip:
        'Το ratio %NSA (ποσοστό No Show Appointments) είναι ένας δείκτης που μετρά το ποσοστό των προγραμματισμένων ραντεβού που δεν πραγματοποιήθηκαν επειδή ο πελάτης δεν προσήλθε, χωρίς να έχει ακυρώσει το ραντεβού του.',
    },
    availableEmployees: {
      title: 'Διαθέσιμοι σήμερα',
      empty: 'Κανένας διαθέσιμος υπάλληλος.',
    },
    nextAppointments: {
      title: 'Επόμενα ραντεβού ημέρας',
      empty: 'Δεν υπάρχουν ραντεβού για σήμερα.',
      defaultService: 'Υπηρεσία',
      with: 'με {{name}}',
    },
    pendingAppointments: {
      title: 'Μη επιβεβαιωμένα ραντεβού',
      empty: 'Δεν υπάρχουν Μη Επιβεβαιωμένα Ραντεβού',
      confirmTooltip: 'Επιβεβαίωση ραντεβού',
      cancelTooltip: 'Ακύρωση ραντεβού',
      openTooltip: 'Άνοιγμα ραντεβού',
      confirmedSnackbar: 'Το ραντεβού επιβεβαιώθηκε.',
      cancelledSnackbar: 'Το ραντεβού ακυρώθηκε.',
      confirmFailed: 'Αποτυχία επιβεβαίωσης ραντεβού',
      cancelFailed: 'Αποτυχία ακύρωσης ραντεβού',
    },
    topClients: {
      title: 'Τοπ 10 πελάτες',
      empty: 'Δεν υπάρχουν δεδομένα',
      loadFailed: 'Αποτυχία φόρτωσης πελατών',
      sortVisits: 'Επισκέψεις',
      sortPayments: 'Πληρωμές',
    },
    topServices: {
      title: 'Τοπ 10 υπηρεσίες',
      empty: 'Δεν υπάρχουν δεδομένα',
      loadFailed: 'Αποτυχία φόρτωσης υπηρεσιών',
      sortCount: 'Ποσότητα',
      sortCost: 'Τζίρος',
    },
    notices: {
      loadFailed: {
        title: 'Δεν ήταν δυνατή η φόρτωση ορισμένων ελέγχων τιμολόγησης',
        description: 'Οι ειδοποιήσεις ρυθμίσεων ενδέχεται να μην είναι πλήρεις. Δοκιμάστε ξανά.',
        cta: 'Δοκιμάστε ξανά',
      },
      noTenantCompanies: {
        title: 'Δεν έχετε καταχωρήσει εταιρεία',
        description: 'Η καταχώρηση εταιρείας είναι απαραίτητη για να μπορέσετε να εκδώσετε τιμολόγια στις Παραγγελίες σας.',
        cta: 'Μεταφορά στις Εταιρείες',
      },
      unlinkedBranches: {
        title: 'Κάποιο ή κάποια από τα καταστήματα σας δεν είναι συνδεδεμένα με τις εταιρείες σας',
        description: 'Η σύνδεση είναι απαραίτητη για να μπορέσετε να εκδώσετε τιμολόγια στις Παραγγελίες σας.',
        cta: 'Μεταφορά στα Καταστήματα',
      },
    },
  },
  apiErrors: {
    erganiInvalidCredentials: 'Λάθος username ή password για την ΕΡΓΑΝΗ',
    branchNameAlreadyExists: 'Υπάρχει ήδη κατάστημα με το όνομα "{{branchName}}". Επιλέξτε διαφορετικό όνομα.',
    branchAddressIncomplete: 'Λείπουν υποχρεωτικά στοιχεία από τη διεύθυνση ({{missingComponents}}). Επιλέξτε άλλη πρόταση.',
    erganiUnavailable: 'Η ΕΡΓΑΝΗ δεν είναι διαθέσιμη αυτή τη στιγμή. Δοκιμάστε ξανά αργότερα.',
    erganiBranchAlreadyAssociated: 'Αυτό το κατάστημα είναι ήδη συνδεδεμένο με άλλο παράρτημα της ΕΡΓΑΝΗΣ.',
    activeBranchLimitReached:
      'Έχετε φτάσει το μέγιστο αριθμό ενεργών καταστημάτων ({{branchLimit}}). Επικοινωνήστε μαζί μας για αναβάθμιση.',
    activeEmployeeLimitReachedForTier:
      "Έχετε φτάσει το όριο ενεργών εργαζομένων για το πακέτο '{{tierCode}}' ({{employeeLimit}}). Αναβαθμίστε το πακέτο σας.",
    orderStatusNotEligible: 'Η κατάσταση της παραγγελίας δεν επιτρέπει πλέον την τιμολόγηση.',
    orderBranchNoCompany: 'Το κατάστημα αυτής της παραγγελίας δεν είναι συνδεδεμένο με εταιρεία.',
    invoicing: {
      AADE_CREDENTIALS_INCOMPLETE: 'Συμπληρώστε μαζί το όνομα χρήστη και τον κωδικό myΑΑΔΕ.',
      AADE_CREDENTIALS_IN_USE:
        'Η επιχείρηση έχει παραστατικά που εκκρεμούν και χρειάζονται αυτά τα στοιχεία. Ολοκληρώστε την έκδοση ή ακυρώστε πρώτα τα εκκρεμή παραστατικά της και μετά αφαιρέστε τα στοιχεία.',
      AADE_CREDENTIALS_INVALID: 'Η ΑΑΔΕ απέρριψε τα στοιχεία σύνδεσης. Ελέγξτε το όνομα χρήστη και τον κωδικό πρόσβασης.',
      AADE_CREDENTIALS_MISSING: 'Για απευθείας διαβίβαση στην ΑΑΔΕ χρειάζονται τα στοιχεία σύνδεσης myΑΑΔΕ της επιχείρησης.',
      FISCAL_PROVIDER_NOT_ACTIVE: 'Για να επιλέξετε τον πάροχο, η επιχείρηση χρειάζεται ενεργό λογαριασμό σε αυτόν.',
      FISCAL_PROVIDER_NOT_READY:
        'Λείπουν στοιχεία της επιχείρησης για τη σύνδεση με τον πάροχο. Ανανεώστε τη σελίδα για να δείτε τι χρειάζεται.',
      FISCAL_PROVIDER_TAX_ID_NOT_CONFIRMED: 'Το ΑΦΜ της επιχείρησης άλλαξε όσο ήταν ανοιχτή η φόρμα. Ελέγξτε το ΑΦΜ και επιβεβαιώστε ξανά.',
      FISCAL_PROVIDER_CONTACT_EMAIL_TAKEN:
        'Το email χρησιμοποιείται ήδη για λογαριασμό άλλης επιχείρησης στον πάροχο. Χρησιμοποιήστε διαφορετικό email.',
      FISCAL_PROVIDER_CONTACT_PHONE_INVALID: 'Το τηλέφωνο επικοινωνίας δεν είναι έγκυρος αριθμός. Ελέγξτε το και δοκιμάστε ξανά.',
      FISCAL_PROVIDER_ALREADY_ACTIVE: 'Η επιχείρηση έχει ήδη ενεργό λογαριασμό στον πάροχο.',
      FISCAL_PROVIDER_ACTIVATION_REFUSED:
        'Ο πάροχος δεν δέχτηκε τη δημιουργία του λογαριασμού. Η υποστήριξη ενημερώθηκε· η επανάληψη δεν θα είχε άλλο αποτέλεσμα.',
      FISCAL_PROVIDER_ACTIVATION_NOT_STARTED: 'Η εγγραφή στον πάροχο δεν έχει ξεκινήσει για αυτή την επιχείρηση.',
      FISCAL_PROVIDER_ACTIVATION_ALREADY_STARTED: 'Η εγγραφή στον πάροχο έχει ήδη ξεκινήσει για αυτή την επιχείρηση. Ανανεώστε τη σελίδα.',
      FISCAL_PROVIDER_ACTIVATION_AWAITING_SUPPORT:
        'Η εγγραφή στον πάροχο εκκρεμεί στην υποστήριξη· δεν χρειάζεται καμία ενέργεια από εσάς.',
      WRAPP_PARTNERS_API_ERROR: 'Δεν ήταν δυνατή η επικοινωνία με τον πάροχο. Δοκιμάστε ξανά αργότερα με «Συνέχεια».',
      NOT_FOUND: 'Το στοιχείο δεν βρέθηκε ή δεν ανήκει πλέον στον λογαριασμό σας. Ανανεώστε τη σελίδα.',
      BAD_REQUEST: 'Κάποια στοιχεία δεν είναι έγκυρα. Ελέγξτε τα πεδία και δοκιμάστε ξανά.',
      PROVIDER_SERIES_NOT_SUPPORTED:
        'Αυτός ο τύπος εκδίδεται μέσω του παρόχου ηλεκτρονικής τιμολόγησης, για τον οποίο η επιχείρηση χρειάζεται ενεργό λογαριασμό. Δεν είναι ακόμα διαθέσιμος.',
      B2C_ISSUANCE_DISABLED: 'Η επιχείρηση δεν εκδίδει αποδείξεις λιανικής από εδώ, αλλά από δικό της σύστημα.',
      CREDIT_NOTE_SERIES_NOT_ALLOWED: 'Οι σειρές πιστωτικών δημιουργούνται αυτόματα μαζί με την αρχική σειρά.',
      SERIES_CODE_ALREADY_EXISTS: 'Ο κωδικός χρησιμοποιείται ήδη από άλλη σειρά αυτού του τύπου.',
      SERIES_CHANNEL_MISMATCH: 'Η σειρά ανήκει σε άλλον τρόπο έκδοσης και δεν μπορεί να χρησιμοποιηθεί.',
      SERIES_COMPANY_MISMATCH: 'Η σειρά ανήκει σε άλλη επιχείρηση. Επιλέξτε άλλη σειρά.',
      SERIES_AUDIENCE_MISMATCH: 'Η σειρά δεν ταιριάζει με τον πελάτη του παραστατικού. Επιλέξτε άλλη σειρά.',
      SERIES_NOT_ACTIVE: 'Η σειρά δεν είναι πλέον ενεργή. Επιλέξτε άλλη σειρά.',
      NO_SERIES_SELECTED: 'Επιλέξτε σειρά αρίθμησης.',
      PROVIDER_ISSUANCE_NOT_SUPPORTED: 'Η έκδοση μέσω του παρόχου ηλεκτρονικής τιμολόγησης δεν είναι ακόμα διαθέσιμη.',
      DOCUMENT_TYPE_MISMATCH: 'Το προσχέδιο δεν είναι ενημερωμένο. Επιλέξτε ξανά τη σειρά αρίθμησης.',
      BRANCH_MISSING_AADE_CODE: 'Λείπει ο κωδικός υποκαταστήματος ΑΑΔΕ του καταστήματος.',
      COUNTERPART_VAT_MISSING: 'Ο πελάτης του τιμολογίου χρειάζεται ΑΦΜ.',
      LINE_NAME_EMPTY: 'Η γραμμή {{lineNumber}} χρειάζεται όνομα.',
      VAT_EXEMPTION_CODE_MISSING: 'Η γραμμή {{lineNumber}} έχει ΦΠΑ 0%, που δεν μπορεί ακόμα να εκδοθεί.',
      LINE_VAT_MISMATCH:
        'Τα ποσά του παραστατικού δεν συμφωνούν. Απορρίψτε το προσχέδιο και δημιουργήστε το ξανά από την παραγγελία. (Γραμμή {{lineNumber}}: αναμενόμενο {{expected}}, βρέθηκε {{actual}})',
      TOTAL_NET_MISMATCH:
        'Τα ποσά του παραστατικού δεν συμφωνούν. Απορρίψτε το προσχέδιο και δημιουργήστε το ξανά από την παραγγελία. (Καθαρή αξία: αναμενόμενο {{expected}}, βρέθηκε {{actual}})',
      TOTAL_VAT_MISMATCH:
        'Τα ποσά του παραστατικού δεν συμφωνούν. Απορρίψτε το προσχέδιο και δημιουργήστε το ξανά από την παραγγελία. (ΦΠΑ: αναμενόμενο {{expected}}, βρέθηκε {{actual}})',
      TOTAL_GROSS_MISMATCH:
        'Τα ποσά του παραστατικού δεν συμφωνούν. Απορρίψτε το προσχέδιο και δημιουργήστε το ξανά από την παραγγελία. (Σύνολο: αναμενόμενο {{expected}}, βρέθηκε {{actual}})',
      TOTAL_NOT_POSITIVE:
        'Τα ποσά του παραστατικού δεν συμφωνούν: δεν έχει γραμμές ή το σύνολο δεν είναι θετικό. Απορρίψτε το προσχέδιο και δημιουργήστε το ξανά από την παραγγελία.',
      INVOICE_NOT_DRAFT: 'Το παραστατικό άλλαξε στο μεταξύ. Η προβολή ανανεώθηκε.',
      INVOICE_NOT_ISSUABLE: 'Το παραστατικό άλλαξε στο μεταξύ. Η προβολή ανανεώθηκε.',
      INVOICE_NOT_CANCELLABLE: 'Το παραστατικό άλλαξε στο μεταξύ. Η προβολή ανανεώθηκε.',
      INVOICE_ALREADY_CANCELLED: 'Το παραστατικό έχει ήδη ακυρωθεί. Η προβολή ανανεώθηκε.',
      ACTIVE_INVOICE_EXISTS: 'Υπάρχει ήδη ενεργό παραστατικό για αυτή την πληρωμή. Η προβολή ανανεώθηκε.',
      ORDER_NO_PAYMENT: 'Η παραγγελία δεν έχει πληρωμή για να τιμολογηθεί.',
      INVOICE_OUTCOME_UNKNOWN: 'Δεν ήταν δυνατός ο έλεγχος στην ΑΑΔΕ. Δοκιμάστε ξανά σε λίγο.',
      PROVIDER_CANCELLATION_NOT_ALLOWED: 'Το παραστατικό εκδόθηκε μέσω παρόχου και διορθώνεται μόνο με πιστωτικό.',
      PAYMENT_METHOD_NOT_SET: 'Ορίστε πρώτα τον τρόπο πληρωμής της πληρωμής και δοκιμάστε ξανά την έκδοση.',
      AADE_CANCELLATION_FAILED: 'Η ΑΑΔΕ αρνήθηκε την ακύρωση. Το παραστατικό παραμένει εκδομένο.',
      AADE_CANCELLATION_UNKNOWN: 'Η ΑΑΔΕ δεν επιβεβαίωσε την ακύρωση. Δοκιμάστε ξανά.',
    },
  },
  validation: {
    money: {
      amountInvalid: 'Παρακαλώ εισάγετε έναν έγκυρο αριθμό',
      amountRequired: 'Το ποσό είναι υποχρεωτικό',
      amountNonNegative: 'Δεν επιτρέπονται αρνητικές τιμές',
      currencyRequired: 'Το νόμισμα είναι υποχρεωτικό',
    },
    logo: {
      fileRequired: 'Παρακαλώ επιλέξτε ένα αρχείο',
      fileSizeMax: 'Το μέγεθος του αρχείου δεν πρέπει να υπερβαίνει τα {{max}}MB',
      fileTypeImage: 'Το αρχείο πρέπει να είναι PNG ή JPEG',
      fileExtensionInvalid: 'Μη έγκυρη επέκταση αρχείου',
      extensionInvalidWithFile: 'Μη έγκυρη επέκταση αρχείου: {{ext}}. Επιτρεπόμενα: .png, .jpg, .jpeg',
      typeInvalid: 'Μη έγκυρος τύπος αρχείου',
      sizeMaxWithCurrent: 'Το μέγεθος του αρχείου δεν πρέπει να υπερβαίνει τα 5MB (τρέχον: {{size}}MB)',
      imageTooSmall: 'Η εικόνα είναι πολύ μικρή: {{width}}×{{height}}px (ελάχιστο: {{min}}px στη μικρότερη πλευρά)',
      imageTooLarge: 'Η εικόνα είναι πολύ μεγάλη: {{width}}×{{height}}px (μέγιστο: {{max}}px στη μεγαλύτερη πλευρά)',
      invalidImageFile: 'Μη έγκυρο αρχείο εικόνας',
      readError: 'Σφάλμα κατά την ανάγνωση της εικόνας',
      qualityExcellent: 'Εξαιρετική ποιότητα',
      qualityGood: 'Καλή ποιότητα',
      qualityAcceptable: 'Αποδεκτή ποιότητα (συνιστάται υψηλότερη ανάλυση)',
      uploaded: 'Το λογότυπο ανέβηκε με επιτυχία',
      uploadFailed: 'Αποτυχία ανεβάσματος. Παρακαλώ δοκιμάστε ξανά.',
    },
  },
  filters: {
    selected_one: '{{count}} επιλεγμένο',
    selected_other: '{{count}} επιλεγμένα',
    dateRangePlaceholder: 'Από - Εώς',
    lastOrder: {
      placeholder: 'Από - Εώς/Κατάσταση',
      date: 'Ημερομηνία',
      status: 'Κατάσταση',
      all: 'Όλες',
    },
  },
  settings: {
    listTitle: 'Ρυθμίσεις',
    tabs: {
      publicBooking: 'Online κρατήσεις',
      serviceGroups: 'Ειδικότητες',
      acquisitionSources: 'Πού μας βρήκατε',
      orderStatuses: 'Καταστάσεις παραγγελίας',
      ergani: 'ΕΡΓΑΝΗ',
      serviceCategories: 'Κατηγορίες υπηρεσιών',
      branches: 'Καταστήματα',
      companies: 'Οι εταιρείες μου',
      invoicing: 'Τιμολόγια',
      tenants: 'Tenants',
    },
    item: {
      available: 'Ενεργό',
      unavailable: 'Μη ενεργό',
    },
    tenants: {
      title: 'Tenants',
      addButton: 'Προσθήκη tenant',
      empty: 'Δεν βρέθηκαν tenants',
      modalTitleAdd: 'Προσθήκη tenant',
      modalTitleEdit: 'Επεξεργασία tenant',
      featurePlaceholder: 'Επιλογή features',
      fields: {
        name: 'Όνομα',
        alias: 'Alias',
        tier: 'Tier',
        features: 'Features',
        firstName: 'Όνομα Tenant Admin',
        lastName: 'Επώνυμο',
        email: 'Email',
        platformAdminEmail: 'Platform Admin Email',
      },
      validation: {
        nameRequired: 'Το όνομα είναι υποχρεωτικό',
        aliasRequired: 'Το alias είναι υποχρεωτικό',
        tierRequired: 'Το tier είναι υποχρεωτικό',
        firstNameRequired: 'Το όνομα είναι υποχρεωτικό',
        lastNameRequired: 'Το επώνυμο είναι υποχρεωτικό',
        emailInvalid: 'Μη έγκυρο email',
        emailRequired: 'Το email είναι υποχρεωτικό',
      },
      snackbars: {
        created: 'O tenant δημιουργήθηκε επιτυχώς!',
        createFailed: 'Η δημιουργία του tenant απέτυχε',
        updated: 'Ο tenant ενημερώθηκε επιτυχώς!',
        updateFailed: 'Η ενημέρωση του tenant απέτυχε',
        copied: 'Αντιγράφηκε!',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
      },
      onboardResult: {
        title: 'Tenant δημιουργήθηκε',
        warning: 'Οι κωδικοί δεν θα εμφανιστούν ξανά μετά το κλείσιμο αυτού του παραθύρου. Σημειώστε τους πριν συνεχίσετε.',
        tenantPasswordLabel: 'Κωδικός διαχειριστή tenant',
        platformPasswordLabel: 'Κωδικός διαχειριστή πλατφόρμας',
        clickHere: 'Click Here',
        show: 'Εμφάνιση',
        hide: 'Απόκρυψη',
        copy: 'Αντιγραφή',
        close: 'Κλείσιμο',
      },
    },
    publicBooking: {
      title: 'Online κρατήσεις',
      branding: {
        title: 'Branding Εταιρείας',
      },
      nameForm: {
        label: 'Επωνυμία εταιρείας',
        helperText: 'Το όνομα που θα εμφανίζεται στους πελάτες κατά την online κράτηση',
        placeholder: 'Εισάγετε το όνομα',
        charactersHelper: '{{count}}/{{max}} χαρακτήρες:',
        save: 'Αποθήκευση',
        updated: 'Το όνομα ενημερώθηκε επιτυχώς',
        saveError: 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση',
      },
      logoUpload: {
        title: 'Ανέβασμα νέου λογότυπου',
        formats: 'Αποδεκτές μορφές: PNG, JPEG • Μέγιστο μέγεθος: 5MB • Διαστάσεις: 100-3000px',
        chooseFile: 'Επιλογή Αρχείου',
        clear: 'Καθαρισμός',
        publish: 'Δημοσίευση',
      },
      logoPreview: {
        defaultCompany: 'Εταιρεία',
        currentTitle: 'Τρέχον Λογότυπο',
        previewTitle: 'Προεπισκόπηση',
        previewBadge: 'Προεπισκόπηση',
        previewLogoAlt: 'Προεπισκόπηση λογότυπου',
        companyLogoAlt: '{{name}} λογότυπο',
        howItWillAppear: 'Έτσι θα εμφανίζεται το λογότυπό σας στη σελίδα κρατήσεων',
        emptyPreview: 'Δεν έχει επιλεγεί αρχείο',
        emptyCurrent: 'Δεν έχει ανέβει λογότυπο',
        urlNote: 'Σημείωση: Τα URLs λήγουν μετά από 10 λεπτά και ανανεώνονται αυτόματα',
      },
      bookingSummary: {
        previewTitle: 'Προεπισκόπηση σελίδας κρατήσεων',
        previewBadge: 'Προεπισκόπηση',
        howItWillAppear: 'Έτσι θα εμφανίζεται το λογότυπό σας στη σελίδα κρατήσεων',
        servicesTitle: 'Επιλεγμένες Υπηρεσίες',
        durationOneHour: '1 ώρα',
        totalCost: 'Συνολικό Κόστος',
        sampleService: 'Κούρεμα χτένισμα',
      },
      wizardSteps: {
        title: 'Βήματα κράτησης',
        description: 'Ρυθμίστε ποια βήματα θα εμφανίζονται στη σελίδα online κρατήσεων.',
        showEmployeeLabel: 'Εμφάνιση επιλογής υπαλλήλου',
        showEmployeeHelper: 'Όταν είναι ενεργοποιημένο, οι πελάτες μπορούν να επιλέξουν συγκεκριμένο υπάλληλο κατά την κράτηση.',
        emailRequiredLabel: 'Υποχρεωτικό email πελάτη',
        emailRequiredHelper:
          'Όταν είναι απενεργοποιημένο, οι πελάτες μπορούν να κάνουν κράτηση χωρίς email. Τα ραντεβού χωρίς email δεν θα λαμβάνουν email επιβεβαίωσης και θα παραμένουν σε κατάσταση αναμονής.',
        loadFailed: 'Αποτυχία φόρτωσης ρυθμίσεων',
        savedSuccess: 'Οι ρυθμίσεις αποθηκεύτηκαν επιτυχώς',
        saveFailed: 'Αποτυχία αποθήκευσης ρυθμίσεων',
      },
      ownerNotifications: {
        title: 'Ειδοποιήσεις καταστηματάρχη',
        description:
          'Λάβετε email όταν ένας πελάτης κάνει κράτηση από τη σελίδα online κρατήσεων. Δεν ισχύει για κρατήσεις από το back office.',
        enableLabel: 'Αποστολή ειδοποιήσεων νέων ραντεβού',
        enableHelper:
          'Λάβετε email όταν ένας πελάτης κλείνει ραντεβού από τις online κρατήσεις. Δεν ισχύει για ραντεβού από το back office.',
        onlyConfirmedLabel: 'Μόνο για επιβεβαιωμένα ραντεβού',
        onlyConfirmedHelper:
          'Όταν είναι ενεργό, λαμβάνετε email μόνο όταν ο πελάτης επιβεβαιώσει το ραντεβού. Απενεργοποιήστε το για να ειδοποιείστε και για τα εκκρεμή (μη επιβεβαιωμένα) ραντεβού.',
        recipientEmailLabel: 'Email παραλήπτη',
        recipientEmailPlaceholder: 'Εισάγετε email',
        recipientEmailHelper: 'Η διεύθυνση στην οποία θα στέλνονται οι ειδοποιήσεις.',
        emailRequired: 'Το email είναι υποχρεωτικό όταν είναι ενεργή μια ειδοποίηση',
        emailInvalid: 'Η διεύθυνση email δεν είναι έγκυρη',
        save: 'Αποθήκευση',
        savedSuccess: 'Οι ρυθμίσεις αποθηκεύτηκαν επιτυχώς',
        saveFailed: 'Αποτυχία αποθήκευσης ρυθμίσεων',
        loadFailed: 'Αποτυχία φόρτωσης ρυθμίσεων',
      },
    },
    ergani: {
      reconnectTitle: 'Επανασύνδεση με ΕΡΓΑΝΗ',
      initialTitle: 'Στοιχεία σύνδεσης επιχείρησης',
      businessDetailsTitle: 'Στοιχεία επιχείρησης',
      branchesTitle: 'Παραρτήματα',
      successChip: 'Επιτυχής σύνδεση με Εργάνη',
      disconnectButton: 'Αποσύνδεση',
      disconnectDialog: {
        title: 'Αποσύνδεση',
        content: 'Είστε σίγουροι ότι θέλετε να αποσυνδέσετε τον λογαριασμό της Εργάνης;',
        confirm: 'Αποσύνδεση',
      },
      reconnectButton: 'Σύνδεση με νέα στοιχεία',
      saveButton: 'Αποθήκευση',
      cancelButton: 'Ακύρωση',
      connectButton: 'Σύνδεση',
      fields: {
        username: 'Username',
        password: 'Password',
        companyName: 'Επωνυμία',
        taxId: 'ΑΦΜ',
        erganiBranch: 'Παράρτημα',
        connectedStore: 'Συνδεδεμένο με κατάστημα',
        selectStore: 'Επιλέξτε',
      },
      snackbars: {
        connected: 'Η σύνδεση με την ΕΡΓΑΝΗ ολοκληρώθηκε επιτυχώς!',
        connectFailed: 'Η σύνδεση με την ΕΡΓΑΝΗ απέτυχε',
        settingsSaved: 'Οι ρυθμίσεις αποθηκεύτηκαν επιτυχώς!',
        settingsSaveFailed: 'Αποτυχία αποθήκευσης ρυθμίσεων',
        mappingSaved: 'Η σύνδεση παραρτήματος αποθηκεύτηκε',
        mappingRemoved: 'Η σύνδεση παραρτήματος αφαιρέθηκε',
        mappingSaveFailed: 'Αποτυχία αποθήκευσης της σύνδεσης παραρτήματος',
        loadFailed: 'Αποτυχία φόρτωσης στοιχείων ΕΡΓΑΝΗ',
      },
      validation: {
        usernameRequired: 'Το username είναι υποχρεωτικό',
        passwordRequired: 'Ο κωδικός είναι υποχρεωτικός',
        storeIdRequired: 'Ο αριθμός είναι υποχρεωτικός',
      },
    },
    serviceCategories: {
      title: 'Κατηγορίες υπηρεσιών',
      addButton: 'Προσθήκη νέας κατηγορίας',
      reorderButton: 'Αλλαγή σειράς εμφάνισης',
      empty: 'Δεν βρέθηκαν κατηγορίες υπηρεσιών',
      tabHeading: 'Υπηρεσίες εντός της κατηγορίας {{name}}',
      tabEmpty: 'Δεν υπάρχουν υπηρεσίες σε αυτήν την κατηγορία',
      inactiveChip: 'Ανενεργή',
      editAction: 'Επεξεργασία',
      modalTitleEdit: 'Επεξεργασία κατηγορίας',
      modalTitleAdd: 'Προσθήκη κατηγορίας',
      fields: {
        name: 'Όνομα κατηγορίας',
        services: 'Υπηρεσίες',
        servicePlaceholder: 'Επιλογή υπηρεσίας',
      },
      validation: {
        nameRequired: 'Το όνομα της κατηγορίας είναι υποχρεωτικό',
        nameDuplicate: 'Υπάρχει ήδη κατηγορία με αυτό το όνομα',
      },
      snackbars: {
        saved: 'Η κατηγορία αποθηκεύτηκε επιτυχώς!',
        updated: 'Η κατηγορία ενημερώθηκε επιτυχώς!',
        deleted: 'Η κατηγορία διαγράφτηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση της κατηγορίας απέτυχε',
        updateFailed: 'Η ενημέρωση της κατηγορίας απέτυχε',
        deleteFailed: 'Η διαγραφή της κατηγορίας απέτυχε',
        reorderSuccess: 'Η σειρά ενημερώθηκε επιτυχώς',
      },
      deleteDialog: {
        title: 'Επιβεβαίωση διαγραφής',
        content: 'Θέλετε σίγουρα να διαγραφεί η κατηγορία {{name}}?',
        confirm: 'Διαγραφή',
      },
      reorder: {
        title: 'Αλλαγή σειράς εμφάνισης κατηγοριών',
        description: 'Προσαρμόστε τη σειρά εμφάνισης των κατηγοριών υπηρεσιών. Οι αλλαγές αποθηκεύονται αυτόματα και εφαρμόζονται άμεσα.',
        empty: 'Δεν υπάρχουν ακόμη καταχωρημένες κατηγορίες',
        close: 'Κλείσιμο',
      },
      services_one: '{{count}} υπηρεσία',
      services_other: '{{count}} υπηρεσίες',
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
    },
    orderStatuses: {
      title: 'Καταστάσεις παραγγελίας',
      defaultLabel: 'Προεπιλεγμένη κατάσταση παραγγελίας',
      orderTitle: 'Σειρά καταστάσεων παραγγελίας',
      active: 'Ενεργή',
      inactive: 'Ανενεργή',
      snackbars: {
        updated: 'To status ενημερώθηκε επιτυχώς',
        updateFailed: 'Κάτι πήγε στραβά.',
      },
    },
    acquisitionSources: {
      title: 'Που μας βρήκατε',
      addButton: 'Προσθήκη πηγής',
      empty: 'Δεν βρέθηκαν πηγές',
      modalTitleEdit: 'Επεξεργασία πηγής',
      modalTitleAdd: 'Προσθήκη πηγής',
      fields: {
        name: 'Πηγή',
      },
      validation: {
        nameRequired: 'Η πηγή είναι υποχρεωτική',
      },
      snackbars: {
        saved: 'Η πηγή αποθηκεύτηκε επιτυχώς!',
        updated: 'Η πηγή ενημερώθηκε επιτυχώς!',
        deleted: 'Η πηγή διαγράφηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση της πηγής απέτυχε',
        updateFailed: 'Η ενημέρωση της πηγής απέτυχε',
        deleteFailed: 'Η διαγραφή της πηγής απέτυχε',
        enableFailed: 'Η ενεργοποίηση της πηγής απέτυχε',
        disableFailed: 'Η απενεργοποίηση της πηγής απέτυχε',
      },
      deleteDialog: {
        title: 'Επιβεβαίωση διαγραφής',
        content: 'Θέλετε σίγουρα να διαγραφεί αυτή η πηγή {{name}}?',
        confirm: 'Διαγραφή',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
    },
    serviceGroups: {
      title: 'Ειδικότητες',
      addButton: 'Προσθήκη ειδικότητας',
      empty: 'Δεν βρέθηκαν ειδικότητες',
      modalTitleEdit: 'Επεξεργασία ειδικότητας',
      modalTitleAdd: 'Προσθήκη ειδικότητας',
      fields: {
        name: 'Όνομα ειδικότητας',
        services: 'Υπηρεσίες',
        servicePlaceholder: 'Επιλογή υπηρεσίας',
      },
      validation: {
        nameRequired: 'Το όνομα είναι υποχρεωτικό',
        servicesRequired: 'Πρέπει να επιλέξετε τουλάχιστον 1 υπηρεσία',
      },
      snackbars: {
        saved: 'Η ειδικότητα αποθηκεύτηκε επιτυχώς!',
        updated: 'Η ειδικότητα ενημερώθηκε επιτυχώς!',
        deleted: 'Η ειδικότητα διαγράφτηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση της ειδικότητας απέτυχε',
        updateFailed: 'Η ενημέρωση της ειδικότητας απέτυχε',
        deleteFailed: 'Η διαγραφή της ειδικότητας απέτυχε',
        enableFailed: 'Η ενεργοποίηση της ειδικότητας απέτυχε',
        disableFailed: 'Η απενεργοποίηση της ειδικότητας απέτυχε',
      },
      deleteDialog: {
        title: 'Επιβεβαίωση διαγραφής',
        content: 'Θέλετε σίγουρα να διαγραφεί η ειδικότητα {{name}}?',
        confirm: 'Διαγραφή',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
    },
    branches: {
      title: 'Καταστήματα',
      addButton: 'Προσθήκη καταστήματος',
      addButtonDisabledTooltip: 'Έχετε φτάσει το μέγιστο αριθμό καταστημάτων. Επικοινωνήστε μαζί μας για αναβάθμιση.',
      empty: 'Δεν βρέθηκαν καταστήματα',
      modalTitleEdit: 'Επεξεργασία καταστήματος',
      modalTitleAdd: 'Προσθήκη καταστήματος',
      linkedCompany: 'Συνδεμένη εταιρεία',
      noCompanyWarning: 'Αυτό το κατάστημα δεν έχει συνδεδεμένη εταιρεία για να μπορέσει να εκδίδει τιμολόγια.',
      addCompany: 'Σύνδεση εταιρείας',
      noTenantCompaniesWarning:
        'Δεν έχετε καταχωρήσει ακόμα εταιρεία. Καταχωρήστε μία και συνδέστε τη με το κατάστημα για να μπορεί να εκδίδει τιμολόγια.',
      registerCompany: 'Καταχώρηση εταιρείας',
      backToList: 'Λίστα καταστημάτων',
      detailTitle: 'Βασικές πληροφορίες',
      fields: {
        name: 'Όνομα καταστήματος',
        address: 'Διεύθυνση',
        linkToCompany: 'Συνδεδεμένη εταιρεία μου',
        aadeBranchCode: 'Υποκατάστημα στην ΑΑΔΕ',
        aadeBranchCodeTooltip: 'Ο αριθμός 0 είναι για την έδρα. Μπορείτε να βρείτε τους αριθμούς εγκατάστασης στον taxis λογαριασμό σας',
      },
      validation: {
        nameRequired: 'Το όνομα καταστήματος είναι υποχρεωτικό',
        addressRequired: 'Η διεύθυνση είναι υποχρεωτική',
        addressNotSpecificEnough: 'Επιλέξτε οδό ή αριθμό οδού από τις προτάσεις',
        aadeBranchCodeInvalid: 'Ο κωδικός υποκαταστήματος πρέπει να είναι θετικός ακέραιος αριθμός',
      },
      snackbars: {
        saved: 'Το κατάστημα αποθηκεύτηκε επιτυχώς!',
        addressRequiredBeforeToggle: 'Προσθέστε διεύθυνση στο κατάστημα πριν το ενεργοποιήσετε ή το απενεργοποιήσετε',
        updated: 'Το κατάστημα ενημερώθηκε επιτυχώς!',
        deleted: 'Το κατάστημα διαγράφηκε επιτυχώς!',
        saveFailed: 'Η αποθήκευση του καταστήματος απέτυχε',
        updateFailed: 'Η ενημέρωση του καταστήματος απέτυχε',
        deleteFailed: 'Η διαγραφή του καταστήματος απέτυχε',
        enableFailed: 'Η ενεργοποίηση του καταστήματος απέτυχε',
        disableFailed: 'Η απενεργοποίηση του καταστήματος απέτυχε',
      },
      deleteDialog: {
        title: 'Επιβεβαίωση διαγραφής',
        content: 'Θέλετε σίγουρα να διαγραφεί το κατάστημα "{{name}}";',
        confirm: 'Διαγραφή',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
    },
    invoicing: {
      title: 'Τιμολόγια',
      companiesLoadFailed: 'Δεν ήταν δυνατή η φόρτωση των εταιρειών σας. Δοκιμάστε ξανά.',
      noCompanies: 'Δεν έχετε καταχωρήσει εταιρεία. Καταχωρήστε μια εταιρεία για να ρυθμίσετε την έκδοση παραστατικών.',
      company: {
        taxId: 'ΑΦΜ {{taxId}}',
      },
      sectionTitle: 'Σειρές αρίθμησης',
      addButton: 'Προσθήκη σειράς',
      empty: 'Δεν έχετε σειρές αρίθμησης.\nΠατήστε "Προσθήκη σειράς" για να δημιουργήσετε μια σειρά.',
      modalTitleAdd: 'Προσθήκη σειράς',
      modalTitleEdit: 'Τροποποίηση σειράς',
      fields: {
        documentType: 'Τύπος παραστατικού',
        seriesCode: 'Κωδικός σειράς',
        name: 'Όνομα σειράς',
        nextInvoiceNumber: 'Επόμενος αριθμός τιμολογίου',
      },
      helperTexts: {
        editWarning: 'Όλες οι εγγραφές που χρησιμοποιούν τη σειρά θα επηρεαστούν από τις αλλαγές.',
        seriesCode: 'Τυπώνεται μαζί με τον αριθμό (π.χ. Α-42) και διαβιβάζεται στο myDATA. Δεν αλλάζει μετά τη δημιουργία.',
        creditNotePair: 'Μαζί δημιουργείται αυτόματα και η σειρά για «{{type}}» με τον ίδιο κωδικό.',
        noCreatableType: 'Με τον τρόπο έκδοσης που έχει αποθηκευτεί για την επιχείρηση δεν μπορεί να δημιουργηθεί νέα σειρά.',
        nextInvoiceNumber:
          'Αφήστε το κενό για να ξεκινήσει από το 1. Αν μεταφέρετε τιμολόγια από άλλο σύστημα, εισάγετε εδώ τον επόμενο αριθμό προς έκδοση.',
      },
      validation: {
        nameRequired: 'Το όνομα σειράς είναι υποχρεωτικό',
        seriesCodeRequired: 'Ο κωδικός σειράς είναι υποχρεωτικός',
        documentTypeRequired: 'Επιλέξτε τύπο παραστατικού',
        seriesCodeTooLong: 'Ο κωδικός σειράς μπορεί να έχει έως 50 χαρακτήρες',
        nextInvoiceNumberInvalid: 'Ο επόμενος αριθμός τιμολογίου πρέπει να είναι ακέραιος τουλάχιστον 1',
      },
      item: {
        notUsed: 'Δεν χρησιμοποιείται ακόμα',
        usedInRecords_one: 'Χρησιμοποιείται σε {{count}} εγγραφή',
        usedInRecords_other: 'Χρησιμοποιείται σε {{count}} εγγραφές',
        defaultChip: 'Προεπιλεγμένη',
        active: 'Ενεργή',
        activeToggle: 'Ενεργή σειρά {{code}}',
        setDefault: 'Ορισμός της σειράς {{code}} ως προεπιλεγμένης',
        edit: 'Τροποποίηση σειράς {{code}}',
        lastIssuedNumber: 'Τελευταίος αριθμός: {{number}}',
        inactiveChip: 'Ανενεργή',
        historyChip: 'Μόνο ιστορικό',
        historyReadOnly:
          'Η σειρά ανήκει σε άλλον τρόπο έκδοσης και κρατιέται μόνο για τα παραστατικά που έχει ήδη εκδώσει. Δεν μπορεί να ενεργοποιηθεί ξανά.',
      },
      tooltips: {
        defaultChip: 'Είναι η σειρά που εμφανίζεται ως προεπιλεγμένη κάθε φορά που δημιουργείται ένα παραστατικό τιμολογίου.',
        cannotEdit:
          'Δε μπορείτε να αλλάξετε την ονομασία της σειράς, γιατί υπάρχουν ένα ή περισσότερα παραστατικά με αυτή τη σειρά που έχουν αποσταλεί στο myDATA.',
        setDefault: 'Ορισμός ως προεπιλεγμένης: θα επιλέγεται αυτόματα στα νέα παραστατικά αυτού του τύπου.',
        cannotDeactivateDefault: 'Για να απενεργοποιήσετε αυτή τη σειρά, επιλέξτε πρώτα μια άλλη ως προεπιλεγμένη.',
      },
      snackbars: {
        created: 'Η σειρά δημιουργήθηκε επιτυχώς!',
        updated: 'Η σειρά ενημερώθηκε επιτυχώς!',
        defaultSet: 'Η σειρά ορίστηκε ως προεπιλεγμένη!',
        deactivated: 'Η σειρά απενεργοποιήθηκε επιτυχώς!',
        activated: 'Η σειρά ενεργοποιήθηκε επιτυχώς!',
        createFailed: 'Η δημιουργία της σειράς απέτυχε',
        updateFailed: 'Η ενημέρωση της σειράς απέτυχε',
        defaultFailed: 'Η αλλαγή προεπιλεγμένης σειράς απέτυχε',
        toggleFailed: 'Η αλλαγή κατάστασης της σειράς απέτυχε',
      },
      buttons: {
        cancel: 'Ακύρωση',
        save: 'Αποθήκευση',
        create: 'Δημιουργία',
      },
      aade: {
        fields: {
          userId: 'Όνομα χρήστη',
          subscriptionKey: 'Κωδικός πρόσβασης',
        },
        validation: {
          userIdRequired: 'Το όνομα χρήστη είναι υποχρεωτικό',
          subscriptionKeyRequired: 'Ο κωδικός πρόσβασης είναι υποχρεωτικός',
        },
      },
      fiscal: {
        loadFailed: 'Δεν ήταν δυνατή η φόρτωση των ρυθμίσεων έκδοσης της επιχείρησης. Δοκιμάστε ξανά.',
        channelTitle: 'Αποδείξεις λιανικής',
        channelDescription: 'Επιλέξτε πώς εκδίδει η επιχείρηση τις αποδείξεις παροχής υπηρεσιών προς ιδιώτες πελάτες.',
        channels: {
          DIRECT: {
            label: 'Απευθείας στην ΑΑΔΕ (myDATA)',
            description:
              'Οι αποδείξεις εκδίδονται από εδώ και διαβιβάζονται απευθείας στο myDATA με τα στοιχεία σύνδεσης myΑΑΔΕ της επιχείρησης.',
          },
          PROVIDER: {
            label: 'Μέσω παρόχου ηλεκτρονικής τιμολόγησης',
            description: 'Οι αποδείξεις εκδίδονται μέσω του πιστοποιημένου παρόχου (Wrapp), ο οποίος τις διαβιβάζει στην ΑΑΔΕ.',
          },
          NONE: {
            label: 'Από δικό της σύστημα',
            description: 'Η επιχείρηση εκδίδει αποδείξεις λιανικής από δικό της σύστημα, οπότε δεν εκδίδονται αποδείξεις λιανικής από εδώ.',
          },
        },
        providerOnboarding: {
          required: 'Για να επιλέξετε τον πάροχο, η επιχείρηση χρειάζεται ενεργό λογαριασμό σε αυτόν.',
          button: 'Σύνδεση με τον πάροχο',
          title: 'Σύνδεση με τον πάροχο ηλεκτρονικής τιμολόγησης',
          loadFailed: 'Δεν ήταν δυνατή η φόρτωση των στοιχείων σύνδεσης. Δοκιμάστε ξανά.',
          startFailed: 'Η έναρξη της σύνδεσης με τον πάροχο απέτυχε',
          resumeFailed: 'Δεν ήταν δυνατή η συνέχιση της εγγραφής. Δοκιμάστε ξανά.',
          statuses: {
            PENDING_ACTIVATION: {
              title: 'Εκκρεμεί η ολοκλήρωση της εγγραφής',
              description:
                'Η εγγραφή ξεκίνησε αλλά δεν έχει ολοκληρωθεί. Μόλις ολοκληρωθεί στον πάροχο, ο λογαριασμός ενεργοποιείται αυτόματα εδώ σε λίγα δευτερόλεπτα.',
            },
            PENDING_MANUAL_LINK: {
              title: 'Εκκρεμεί σύνδεση του υπάρχοντος λογαριασμού',
              description:
                'Δηλώσατε ότι η επιχείρηση έχει ήδη λογαριασμό στον πάροχο. Η υποστήριξη ενημερώθηκε και θα συνδέσει τον λογαριασμό· δεν χρειάζεται καμία ενέργεια από εσάς.',
            },
            FAILED: {
              title: 'Η σύνδεση με τον πάροχο δεν ολοκληρώθηκε',
              description:
                'Ο πάροχος δεν δέχτηκε τη δημιουργία του λογαριασμού. Η υποστήριξη ενημερώθηκε και θα επικοινωνήσει μαζί σας· η επανάληψη της ενέργειας δεν θα είχε άλλο αποτέλεσμα.',
            },
          },
          checklist: {
            title: 'Λείπουν στοιχεία της επιχείρησης',
            description: 'Συμπληρώστε τα παρακάτω στα στοιχεία της εταιρείας πριν τη σύνδεση με τον πάροχο.',
          },
          details: {
            description: 'Με αυτά τα στοιχεία δημιουργείται ο λογαριασμός της επιχείρησης στον πάροχο.',
            emailHint: 'Το email συνδέεται μόνιμα με τον λογαριασμό στον πάροχο και δεν μπορεί να χρησιμοποιηθεί για δεύτερο λογαριασμό.',
          },
          fields: {
            contactEmail: 'Email επικοινωνίας',
            contactPhone: 'Τηλέφωνο επικοινωνίας',
          },
          confirmTaxId: {
            warningTitle: 'Το ΑΦΜ δεν μπορεί να αλλάξει μετά την ενεργοποίηση',
            warning:
              'Ο πάροχος συνδέει το ΑΦΜ με τον λογαριασμό οριστικά. Κάθε νομικό πρόσωπο χρειάζεται δικό του λογαριασμό και δική του συνδρομή.',
            taxIdLabel: 'ΑΦΜ που θα συνδεθεί',
            description: 'Ελέγξτε ότι το ΑΦΜ και η επωνυμία είναι σωστά πριν συνεχίσετε.',
          },
          existingAccount: {
            question: 'Έχετε ήδη λογαριασμό στο Wrapp;',
            description:
              'Απαντήστε με προσοχή: αν η επιχείρηση έχει δικό της λογαριασμό και προχωρήσουμε σε νέα εγγραφή, ο πάροχος την απορρίπτει οριστικά και χρειάζεται αίτημα στην υποστήριξή του.',
            answers: {
              false: {
                label: 'Όχι, δεν έχουμε λογαριασμό',
                description: 'Θα δημιουργηθεί νέος λογαριασμός και θα μεταφερθείτε στον πάροχο για να τον ολοκληρώσετε.',
              },
              true: {
                label: 'Ναι, έχουμε ήδη λογαριασμό',
                description: 'Δεν θα δημιουργηθεί νέος λογαριασμός. Θα ενημερωθεί η υποστήριξη για να συνδέσει τον υπάρχοντα.',
              },
            },
          },
          manualLink: {
            title: 'Η υποστήριξη θα συνδέσει τον λογαριασμό σας',
            description:
              'Δεν δημιουργήθηκε νέος λογαριασμός. Αυτά είναι τα στοιχεία που θα σταλούν στον πάροχο για τη σύνδεση του υπάρχοντος λογαριασμού σας.',
            taxId: 'ΑΦΜ',
            contactEmail: 'Email επικοινωνίας',
            partnerUserId: 'Κωδικός σύνδεσης',
          },
          actions: {
            cancel: 'Ακύρωση',
            back: 'Πίσω',
            next: 'Συνέχεια',
            confirmTaxId: 'Επιβεβαιώνω το ΑΦΜ',
            start: 'Έναρξη εγγραφής',
            resume: 'Συνέχεια',
            close: 'Κλείσιμο',
          },
          validation: {
            emailRequired: 'Το email επικοινωνίας είναι υποχρεωτικό',
            emailInvalid: 'Το email δεν είναι έγκυρο',
            phoneRequired: 'Το τηλέφωνο επικοινωνίας είναι υποχρεωτικό',
            phoneInvalid: 'Το τηλέφωνο επικοινωνίας δεν είναι έγκυρο',
          },
        },
        credentials: {
          title: 'Στοιχεία σύνδεσης myΑΑΔΕ',
          description:
            'Χρησιμοποιούνται για τη διαβίβαση των αποδείξεων στο myDATA. Το όνομα χρήστη και ο κωδικός αλλάζουν πάντα μαζί και ελέγχονται με την ΑΑΔΕ πριν αποθηκευτούν.',
          subscriptionKeyStored: 'Έχει αποθηκευτεί',
          change: 'Αλλαγή στοιχείων',
          cancelChange: 'Ακύρωση αλλαγής',
          remove: 'Αφαίρεση στοιχείων',
          removeHintDirect: 'Για να αφαιρέσετε τα στοιχεία, επιλέξτε και αποθηκεύστε πρώτα άλλον τρόπο έκδοσης.',
          storedNotInUse: 'Υπάρχουν αποθηκευμένα στοιχεία myΑΑΔΕ ({{maskedUserId}}) που δεν χρησιμοποιούνται με αυτόν τον τρόπο έκδοσης.',
          removeDialog: {
            title: 'Αφαίρεση στοιχείων myΑΑΔΕ',
            content: 'Είστε σίγουροι ότι θέλετε να αφαιρέσετε τα στοιχεία σύνδεσης myΑΑΔΕ της επιχείρησης;',
            confirm: 'Αφαίρεση',
            cancel: 'Ακύρωση',
          },
        },
        save: 'Αποθήκευση',
        snackbars: {
          saved: 'Οι ρυθμίσεις έκδοσης της επιχείρησης αποθηκεύτηκαν',
          saveFailed: 'Η αποθήκευση των ρυθμίσεων έκδοσης απέτυχε',
          credentialsRemoved: 'Τα στοιχεία σύνδεσης myΑΑΔΕ αφαιρέθηκαν',
          outcomeUnconfirmed:
            'Δεν λάβαμε επιβεβαίωση για την αποθήκευση. Οι ρυθμίσεις φορτώθηκαν ξανά: ελέγξτε αν η αλλαγή σας αποθηκεύτηκε.',
        },
      },
    },
  },
  companies: {
    listTitle: 'Εταιρείες',
    addCompany: 'Προσθήκη εταιρείας',
    backToList: 'Λίστα εταιρειών',
    empty: 'Δεν βρέθηκαν εταιρείες',
    columns: {
      taxId: 'ΑΦΜ',
      legalName: 'Επωνυμία',
      registeredAddress: 'Διεύθυνση',
      tradeName: 'Δραστηριότητα',
      companyType: 'Τύπος εταιρείας',
      country: 'Χώρα',
    },
    fields: {
      taxId: 'ΑΦΜ',
      legalName: 'Επωνυμία',
      registeredAddressVies: 'Διεύθυνση VIES',
      address: 'Διεύθυνση',
      country: 'Χώρα',
      activity: 'Δραστηριότητα',
      companyType: 'Τύπος εταιρείας',
      tradeName: 'Διακριτικός τίτλος',
      location: 'Τοποθεσία',
    },
    sections: {
      basicInfo: 'Βασικές πληροφορίες',
      linkedContacts: 'Συνδεδεμένες επαφές',
    },
    contactColumns: {
      lastName: 'Επώνυμο',
      firstName: 'Όνομα',
      role: 'Ρόλος',
    },
    actions: {
      linkContact: 'Σύνδεση επαφής',
      updateViaVies: 'Ενημέρωση μέσω VIES',
      lastUpdated: 'Τελευταία ενημέρωση: {{date}}',
      viaVies: 'μέσω VIES',
    },
    search: {
      mobilePlaceholder: 'Όνομα, ΑΦΜ, Χώρα',
    },
    tabs: {
      details: 'Στοιχεία',
      contacts: 'Επαφές',
    },
    addModal: {
      searchTitle: 'Αναζήτηση σε VIES/TaxisNet',
      detailsTitle: 'Στοιχεία εταιρείας από VIES/TaxisNet',
      manualTitle: 'Προσθήκη εταιρείας',
      manualEntry: 'Χειροκίνητη προσθήκη',
      newSearch: 'Νέα Αναζήτηση',
    },
    unlinkContact: {
      title: 'Αφαίρεση επαφής από την εταιρεία',
      content: 'Θέλετε να αφαιρέσετε την επαφή {{contactName}} από την εταιρεία {{companyName}}?',
      confirm: 'Αφαίρεση',
    },
    snackbars: {
      notFound: 'Η εταιρεία δεν βρέθηκε',
      updated: 'Η εταιρεία ενημερώθηκε',
      saved: 'Η εταιρεία αποθηκεύτηκε επιτυχώς!',
      contactLinked: 'Η επαφή συνδέθηκε με την εταιρεία',
      contactUnlinked: 'Η επαφή αφαιρέθηκε από την εταιρεία',
      taxIdAlreadyExists: 'Η εταιρεία με το παρόν ΑΦΜ έχει ήδη καταχωρηθεί',
      viesNotActive: 'Το παρόν ΑΦΜ δεν είναι ενεργό στο VIES',
      viesCredentialsInvalid: 'Τα στοιχεία σύνδεσης δεν είναι σωστά',
      viesUnavailable: 'Η υπηρεσία VIES δεν είναι διαθέσιμη',
    },
    validation: {
      taxIdRequired: 'Το ΑΦΜ είναι υποχρεωτικό',
      countryRequired: 'Η χώρα είναι υποχρεωτική',
      legalNameRequired: 'Η επωνυμία είναι υποχρεωτική',
      activityRequired: 'Η δραστηριότητα είναι υποχρεωτική',
      addressRequired: 'Η διεύθυνση είναι υποχρεωτική',
      companyTypeRequired: 'Ο τύπος εταιρείας είναι υποχρεωτικός',
    },
  },
};

export default el;
